/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Partial reusable interface that mirrors 'interface IQueryPaginatedResponse<T>' */
export interface PaginatedResponse {
  total: number;
  count: number;
  page: number;
  limit: number;
}

export enum CompanyType {
  None = "none",
  Carrier = "carrier",
  Member = "member",
  Tenant = "tenant",
}

export enum ContractLegQueryFilterLegGrouping {
  Distinct = "distinct",
  AllActive = "all_active",
  All = "all",
}

export enum ContractStatusType {
  Draft = "draft",
  Published = "published",
  Accepted = "accepted",
  Active = "active",
  Expired = "expired",
}

export enum ContractInitiatorType {
  Carrier = "carrier",
  Tenant = "tenant",
}

export enum ContractFieldType {
  Leg = "leg",
  Cost = "cost",
  Time = "time",
}

/** @pattern ^\(\d+?(\.\d+),\d+?(\.\d+)\)$ */
export type QueryCoordinate = string;

export enum UserGroupName {
  SearchUsers = "searchUsers",
  CarrierUsers = "carrierUsers",
  Admins = "admins",
}

export enum EquipmentType {
  Value20FtDry = "20ft dry",
  Value40FtDry = "40ft dry",
  Value45FtHcDry = "45ft hc dry",
  Value20FtNor = "20ft nor",
  Value40FtNor = "40ft nor",
}

export enum Modality {
  Seafreight = "Seafreight",
  InlandHaulage = "Inland haulage",
  OutportAdditional = "Outport additional",
}

export enum Sailings {
  Daily = "Daily",
  Weekly = "Weekly",
  Monthly = "Monthly",
  Every2Weeks = "Every 2 Weeks",
  Every3Weeks = "Every 3 Weeks",
  Every2Months = "Every 2 Months",
  Every3Months = "Every 3 Months",
  OnInducement = "On Inducement",
}

export enum DaysType {
  BusinessDays = "businessDays",
  CalendarDays = "calendarDays",
}

export enum TerminusType {
  Origin = "origin",
  Destination = "destination",
}

export enum LocationType {
  Unlocode = "unlocode",
  UnlocodeGroup = "unlocodeGroup",
}

export enum UnlocodeGroupType {
  PortGroup = "port_group",
  Continent = "continent",
  Country = "country",
  TradeRegion = "trade_region",
  LocationType = "location_type",
}

export enum ContractLegStatus {
  Accepted = "accepted",
  Declined = "declined",
}

export enum TenderRegionTypes {
  Europe = "Europe",
  Asia = "Asia",
  Row = "Row",
  Uk = "Uk",
}

export enum ReportType {
  Member = "member",
  Carrier = "carrier",
}

export enum ReportedBy {
  Member = "member",
  Carrier = "carrier",
  Both = "both",
}

/** Type of VID batch */
export enum VIDType {
  Vid = "vid",
  OssiVid = "ossi_vid",
  TopUpVid = "top_up_vid",
}

export enum ContractActions {
  Self = "self",
  Download = "download",
  UpdateContractCodeFiltered = "update_contract_code_filtered",
  Create = "create",
  Import = "import",
  Accept = "accept",
  Decline = "decline",
  Publish = "publish",
  Unpublish = "unpublish",
  Delete = "delete",
  Update = "update",
}

export enum FileTypes {
  NewsAttachment = "NewsAttachment",
  NewsImage = "NewsImage",
  TenderSheet = "TenderSheet",
  TenderResponseSheet = "TenderResponseSheet",
  AmendmentSheet = "AmendmentSheet",
  ContractSheet = "ContractSheet",
  ShipmentReportSheet = "ShipmentReportSheet",
}

export enum CostCalculationCategory {
  BaseRate = "baseRate",
  Applied = "applied",
  NotApplied = "notApplied",
}

export enum TimeCalculationCategory {
  Transit = "transit",
  FreeTime = "freeTime",
}

export enum AmendmentChangeType {
  Change = "change",
  Decline = "decline",
  Accept = "accept",
  Unchanged = "unchanged",
  Reactivated = "reactivated",
}

export enum AmendmentCompareSourceType {
  Contract = "contract",
  Amendment = "amendment",
}

export enum AliasType {
  Unlocode = "unlocode",
  Carrier = "carrier",
  Member = "member",
  Scac = "scac",
  ContractCode = "contractCode",
}

export enum PortalCostTypes {
  CostAmsEnsFiling = "CostAmsEnsFiling",
  CostBookingFee = "CostBookingFee",
  CostCustomsTransitDocs = "CostCustomsTransitDocs",
  CostFreightIncrease = "CostFreightIncrease",
  CostFreightIncreaseUpdate = "CostFreightIncreaseUpdate",
  CostIsps = "CostIsps",
  CostLinesDocs = "CostLinesDocs",
  CostVgmDeclaration = "CostVgmDeclaration",
  CostWeighing = "CostWeighing",
}

export enum ApplyTypes {
  Never = "Never",
  Hidden = "Hidden",
  Always = "Always",
  IfOriginInGroup = "IfOriginInGroup",
  IfDestinationInGroup = "IfDestinationInGroup",
  IfOriginAndDestinationInGroup = "IfOriginAndDestinationInGroup",
}

export enum TierTypes {
  Bronze = "bronze",
  Silver = "silver",
  Gold = "gold",
  Platinum = "platinum",
  Custom1 = "custom1",
  Custom2 = "custom2",
  Custom3 = "custom3",
}

export enum TierRegions {
  Ex = "Ex",
  Im = "Im",
  Row = "Row",
}

export enum NotificationTypes {
  Task = "Task",
  NewUser = "New User",
  NewTender = "New Tender",
  CompanyUpdates = "Company Updates",
  TenderDueDateApproaching = "Tender Due Date Approaching",
  TenderDueDateApproachingNoResponses = "Tender Due Date Approaching No Responses",
  TenderDueDateReached = "Tender Due Date Reached",
  TenderResponseSubmitted = "Tender Response Submitted",
  TenderResponseAccepted = "Tender Response Accepted",
  TenderResponseDeclined = "Tender Response Declined",
  AmendmentReceived = "Amendment Received",
  AmendmentAccepted = "Amendment Accepted",
  AmendmentDeclined = "Amendment Declined",
  AmendmentActive = "Amendment Active",
  AmendmentExpired = "Amendment Expired",
  AmendmentExpirationApproaching = "Amendment Expiration Approaching",
  ContractExpired = "Contract Expired",
  ContractActive = "Contract Active",
  ContractExpirationApproaching = "Contract Expiration Approaching",
  Maintenance = "Maintenance",
  NewsItemPublished = "News Item Published",
  Notification = "Notification",
  WeeklyReport = "Weekly Report",
}

/**
 * Event types for the contract leg aggregate:
 *   * `TenderLegAcceptedByCarrier` - Carrier accepted a tender leg
 *   * `TenderLegDeclinedByCarrier` - Carrier declined a tender leg
 *   * `TenderLegUpdatedByCarrier` - Carrier updated a tender response leg
 *   * `CustomContractPublishedByAdmin` - Admin published a custom contract
 *   * `CustomContractUnPublishedByAdmin` - Admin unpublished a custom contract
 *   * `CustomContractReplacedByAdmin` - Admin replaced a custom contract
 *   * `CustomContractExpired` - Custom contract expired by system (nightly)
 *   * `TenderResponseApprovedByAdmin` - Admin approved a tender response
 *   * `TenderResponseDeclinedByAdmin` - Admin declined a tender response
 *   * `TenderResponseReplacedByCarrier` - Carrier replaced a tender response
 *   * `TenderResponseExpired` - Tender response expired by system (nightly)
 *   * `ContractLegAmendedByCarrier` - Carrier amended a contract leg
 *   * `ContractLegReactivatedByCarrier` - Carrier reactivated an expired contract leg via amendment
 *   * `ContractLegDeclinedByCarrier` - Carrier declined a contract leg via amendment
 *   * `ContractLegAcceptedByCarrier` - Carrier accepted a contract leg via amendment (within tender)
 *   * `ContractLegAddedByCarrier` - Carrier added a leg via amendment (outside original tender)
 *   * `ContractLegUpdatedByAdmin` - Admin updated a contract leg's contract code
 *   * `LegContractCodeSetByAdmin` - Admin updated contract legs' contract code using filters
 *   * `ContractLegExpired` - Contract leg expired by system (nightly)
 *   * `AmendmentApprovedByAdmin` - Admin approved an amendment
 *   * `AmendmentDeclinedByAdmin` - Admin declined an amendment
 *   * `AmendmentReplacedByCarrier` - Carrier replaced an amendment
 *   * `AmendmentExpired` - Amendment expired by system (nightly)
 */
export enum ContractLegEventType {
  TenderLegAcceptedByCarrier = "TenderLegAcceptedByCarrier",
  TenderLegDeclinedByCarrier = "TenderLegDeclinedByCarrier",
  TenderLegUpdatedByCarrier = "TenderLegUpdatedByCarrier",
  CustomContractPublishedByAdmin = "CustomContractPublishedByAdmin",
  CustomContractUnPublishedByAdmin = "CustomContractUnPublishedByAdmin",
  CustomContractReplacedByAdmin = "CustomContractReplacedByAdmin",
  CustomContractExpired = "CustomContractExpired",
  TenderResponseApprovedByAdmin = "TenderResponseApprovedByAdmin",
  TenderResponseDeclinedByAdmin = "TenderResponseDeclinedByAdmin",
  TenderResponseReplacedByCarrier = "TenderResponseReplacedByCarrier",
  TenderResponseExpired = "TenderResponseExpired",
  ContractLegAmendedByCarrier = "ContractLegAmendedByCarrier",
  ContractLegReactivatedByCarrier = "ContractLegReactivatedByCarrier",
  ContractLegDeclinedByCarrier = "ContractLegDeclinedByCarrier",
  ContractLegAcceptedByCarrier = "ContractLegAcceptedByCarrier",
  ContractLegAddedByCarrier = "ContractLegAddedByCarrier",
  ContractLegUpdatedByAdmin = "ContractLegUpdatedByAdmin",
  LegContractCodeSetByAdmin = "LegContractCodeSetByAdmin",
  ContractLegExpired = "ContractLegExpired",
  AmendmentApprovedByAdmin = "AmendmentApprovedByAdmin",
  AmendmentDeclinedByAdmin = "AmendmentDeclinedByAdmin",
  AmendmentReplacedByCarrier = "AmendmentReplacedByCarrier",
  AmendmentExpired = "AmendmentExpired",
}

/**
 * Sort order:
 *  * `ReportedByMember` - Member reports a shipment (raw data)
 *  * `ReportedByCarrier` - Carrier reports a shipment (raw data)
 *  * `ImportPatchedBySystem` - Bad data is touched up, aliases applied etc.
 *  * `ImportDuplicateIgnoredBySystem` - Full duplicate was immediately ignored
 *  * `ImportDuplicateMergedBySystem` - If changes are in non-authoritative fields, e.g. member says something changed but carrier already reported a different value, they are ignored
 *  * `ImportDuplicateSelectedAndProcessedByAdmin` - Admin resolved a conflict between imports by selecting the correct one in the UI
 *  * `ImportUpdatedByAdmin` - Admin updated fields in the UI
 *  * `ImportsMergedAndProcessedByAdmin` - Admin resolved a conflict between imports in the UI
 *  * `ImportDeletedByAdmin` - Admin deletes an import shipment from the overview or during duplicate resolution
 *  * `DuplicateMergedAndProcessedByAdmin` - Admin resolved a conflict with existing OBL in the UI
 *  * `ProcessedByAdmin` - Import was converted to an OBL, shipment available for invoice
 *  * `UpdatedByAdmin` - OBL was updated by admin in the UI
 *  * `UpdatedBySystem` - OBL was updated by the system (carrier change, member change, TEU change)
 *  * `CarrierInvoiced` - OBL was included in an invoice by admin or auto-invoiced by system on member change
 *  * `CarrierInvoiceCreatedMarker` - Marker event to process batches of invoice rows and active shipments
 *  * `CarrierCredited` - OBL was included in a credit by admin or auto-credited by system on member change
 *  * `CarrierCreditCreatedMarker` - Marker event to process batches of credit rows and active shipments
 *  * `PaymentMadeByCarrier` - Carrier made a payment on an invoice
 *  * `PaymentMarker` - Marker event to process batches of invoice rows and active shipments
 *  * `VIDBatched` - OBL was included in a VID batch
 *  * `TopUpVIDBatched` - OBL was included in a top-up VID batch
 *  * `VIDBatchCreatedMarker` - Marker event to process batches of VID batch rows and active shipments
 *  * `VIDCorrectionQueued` - VID was corrected for an OBL (e.g. member change)
 *  * `VIDCorrectionBatched` - Corrected VID was included in a VID batch
 */
export enum ShipmentEventType {
  ReportedByMember = "ReportedByMember",
  ReportedByCarrier = "ReportedByCarrier",
  ImportPatchedBySystem = "ImportPatchedBySystem",
  ImportDuplicateIgnoredBySystem = "ImportDuplicateIgnoredBySystem",
  ImportDuplicateMergedBySystem = "ImportDuplicateMergedBySystem",
  ImportUpdatedByAdmin = "ImportUpdatedByAdmin",
  ImportDuplicateSelectedAndProcessedByAdmin = "ImportDuplicateSelectedAndProcessedByAdmin",
  ImportsMergedAndProcessedByAdmin = "ImportsMergedAndProcessedByAdmin",
  ImportDeletedByAdmin = "ImportDeletedByAdmin",
  DuplicateMergedAndProcessedByAdmin = "DuplicateMergedAndProcessedByAdmin",
  ProcessedByAdmin = "ProcessedByAdmin",
  UpdatedByAdmin = "UpdatedByAdmin",
  UpdatedBySystem = "UpdatedBySystem",
  CarrierInvoiced = "CarrierInvoiced",
  CarrierInvoiceCreatedMarker = "CarrierInvoiceCreatedMarker",
  CarrierCredited = "CarrierCredited",
  CarrierCreditCreatedMarker = "CarrierCreditCreatedMarker",
  PaymentMadeByCarrier = "PaymentMadeByCarrier",
  PaymentMarker = "PaymentMarker",
  VIDBatched = "VIDBatched",
  TopUpVIDBatched = "TopUpVIDBatched",
  VIDBatchCreatedMarker = "VIDBatchCreatedMarker",
  VIDCorrectionQueued = "VIDCorrectionQueued",
  VIDCorrectionBatched = "VIDCorrectionBatched",
}

export enum ShipmentStatus {
  Error = "error",
  Warning = "warning",
  Correct = "correct",
}

export enum ShipmentDuplicateResolution {
  Delete = "Delete",
  ImportMerge = "ImportMerge",
  ShipmentMerge = "ShipmentMerge",
  Select = "Select",
}

/**
 * Examples:
 *  * `ISO8601` - 1970-01-31
 *  * `EUExtended` - 31-01-1970
 *  * `EU` - 31/01/1970
 *  * `US` - 01/31/1970
 *  * `Long` - Jan. 31, 1970
 *  * `SV` - 31/01-1970
 *  * `YY_MM_DD` - 70/01/31
 *  * `DD_MM_YY` - 31/01/70
 *  * `MM_DD_YY` - 01/31/70
 */
export enum DateFormats {
  ISO8601 = "ISO8601",
  EUExtended = "EUExtended",
  EU = "EU",
  US = "US",
  Long = "Long",
  SV = "SV",
  YY_MM_DD = "YY_MM_DD",
  DD_MM_YY = "DD_MM_YY",
  MM_DD_YY = "MM_DD_YY",
}

export enum TimeFormats {
  Value24Hour = "24Hour",
  Value12Hour = "12Hour",
}

export enum NumberFormats {
  CommaDecimal = "CommaDecimal",
  DotDecimal = "DotDecimal",
  SpaceDecimal = "SpaceDecimal",
}

export interface LegBase {
  originCountry: string;
  originPlace: string;
  destinationCountry: string;
  destinationPlace: string;
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  /** @format modality-enum */
  modality: Modality;
  origin?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  destination?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
}

export interface EnvDTO {
  productMode: string;
  logoPublicUrl: string;
  headerLogoPublicUrl: string;
  coverImagePublicUrl: string;
  publicEmail: string;
  disclaimer: string;
  address: string;
  region: string;
  domain: string;
  tenantName: string;
}

export type ContractAccessDTO = {
  companyUid: string;
  companyName: string;
  /** @format date-time */
  dueDate?: Date | null;
  /** @format date-time */
  createdAt?: Date;
  /** @format date-time */
  updatedAt?: Date;
};

export type ExtendedContractAccessDTO = {
  companyUid: string;
  companyName: string;
  /** @format date-time */
  dueDate?: Date | null;
  /** @format date-time */
  createdAt?: Date;
  /** @format date-time */
  updatedAt?: Date;
} & {
  isDeletable?: boolean;
};

export interface AuthUserDTO {
  id: string;
  token?: string | null;
  refreshToken?: string | null;
  isBlocked: boolean;
  totpEnabled: boolean;
  email: string;
  company: {
    uid: string;
    /** @format company-type-enum */
    companyType: CompanyType;
    name: string;
    address: string;
    postCode: string;
    city: string;
    country: string;
    website: string;
    phone: string;
    fax?: string | null;
    invoiceAddress: string;
    invoicePostCode: string;
    invoiceCity: string;
    invoiceCountry: string;
    vat: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
    carrierDetails?: {
      accountDebit: string;
      accountCredit: string;
      contact: string;
      scac: string;
      oblLength: number | null;
    };
    memberDetails?: {
      eori: string;
      membershipNumber: string;
      osaAccountNumber: string;
      onmiAccountNumber: string;
      osaMember: boolean;
      ossiMember: boolean;
      affiliateOffice: boolean;
    };
    /** @default false */
    fromPortal?: boolean;
  };
  groups: string[];
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
}

export interface AuthLoginResponseDTO {
  id?: string | null;
  token?: string | null;
  refreshToken?: string | null;
  isBlocked?: boolean;
  email: string;
  company?: {
    uid: string;
    /** @format company-type-enum */
    companyType: CompanyType;
    name: string;
    address: string;
    postCode: string;
    city: string;
    country: string;
    website: string;
    phone: string;
    fax?: string | null;
    invoiceAddress: string;
    invoicePostCode: string;
    invoiceCity: string;
    invoiceCountry: string;
    vat: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
    carrierDetails?: {
      accountDebit: string;
      accountCredit: string;
      contact: string;
      scac: string;
      oblLength: number | null;
    };
    memberDetails?: {
      eori: string;
      membershipNumber: string;
      osaAccountNumber: string;
      onmiAccountNumber: string;
      osaMember: boolean;
      ossiMember: boolean;
      affiliateOffice: boolean;
    };
    /** @default false */
    fromPortal?: boolean;
  };
  groups?: string[];
  mfaRequired: boolean;
  mfaToken?: string | null;
  totpEnabled: boolean;
  /** @format date-time */
  createdAt?: Date | null;
  /** @format date-time */
  updatedAt?: Date | null;
}

export interface TotpSetupDTO {
  setupToken: string;
  /**
   * otpauth:// URI used by authenticator apps
   * @format uri
   */
  otpauthUri: string;
  secret: string;
  issuer: string;
  /** @format email */
  email: string;
}

export interface TotpStatusDTO {
  enabled: boolean;
  /** @format date-time */
  enabledAt?: Date | null;
}

export interface UserDTO {
  id: string;
  uid: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string;
  language?: string;
  country?: string | null;
  phone?: string | null;
  isBlocked: boolean;
  isSuperAdmin: boolean;
  invitationConfirmed: boolean;
  groups?: UserGroupName[];
  company?: {
    uid: string;
    /** @format company-type-enum */
    companyType: CompanyType;
    name: string;
    address: string;
    postCode: string;
    city: string;
    country: string;
    website: string;
    phone: string;
    fax?: string | null;
    invoiceAddress: string;
    invoicePostCode: string;
    invoiceCity: string;
    invoiceCountry: string;
    vat: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
    carrierDetails?: {
      accountDebit: string;
      accountCredit: string;
      contact: string;
      scac: string;
      oblLength: number | null;
    };
    memberDetails?: {
      eori: string;
      membershipNumber: string;
      osaAccountNumber: string;
      onmiAccountNumber: string;
      osaMember: boolean;
      ossiMember: boolean;
      affiliateOffice: boolean;
    };
    /** @default false */
    fromPortal?: boolean;
  };
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
}

export interface UnlocodeDTO {
  unlocode: string;
  countryCode: string;
  placeCode: string;
  name: string;
  plainName: string;
  coordinates?: {
    long?: number;
    lat?: number;
  };
  subDivision: string;
  status: string;
  sourceUpdated: string;
  IATA: string;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
}

export interface UnlocodeGroupDTO {
  id: string;
  name: string;
  /** @format unlocodegroup-type-enum */
  type: UnlocodeGroupType;
  description?: string;
}

export interface UnlocodePaginatedResult {
  result?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  }[];
  page?: number;
  limit?: number;
  count?: number;
  total?: number;
}

export interface ContractFieldDTO {
  name: string;
  displayName: string;
  isActive: boolean;
  isRequired: boolean;
  isConfigurable: boolean;
  /** @format contract-field-enum */
  fieldType: ContractFieldType;
  /** @format date-time */
  createdAt?: Date;
  /** @format date-time */
  updatedAt?: Date;
}

export interface AmendmentDTO {
  title: string;
  uid: string;
  hasValidationErrors: boolean;
  parentContractUid?: string;
  contractCode: string | null;
  company?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  /** @format contract-status-type-enum */
  status: ContractStatusType;
  note?: string;
  contractFieldsLegs?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  contractFieldsCost?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  contractFieldsTime?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  /** @format date-time */
  publishedAt?: Date;
  /** @format date-time */
  acceptedAt?: Date;
  /** @format date-time */
  activeAt: Date;
  /** @format date-time */
  expiredAt: Date;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
  links?: {
    /** @format contract-actions-enum */
    rel: ContractActions;
    uri?: string | null;
    disabled?: boolean;
  }[];
}

export interface SimpleAmendmentDTO {
  uid: string;
  title: string;
  parentContractUid?: string;
  contractCode: string | null;
  company?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  note?: string;
  /** @format date-time */
  publishedAt?: Date;
  /** @format date-time */
  acceptedAt?: Date;
  /** @format date-time */
  activeAt: Date;
  /** @format date-time */
  expiredAt: Date;
}

export interface TenderDTO {
  uid: string;
  hasValidationErrors?: boolean;
  contractFieldsLegs?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  contractFieldsCost?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  contractFieldsTime?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  title: string;
  parentTenderUid?: string;
  company?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  /** @format contract-status-type-enum */
  status: ContractStatusType;
  companiesWithAccess?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  }[];
  contractAccess?: {
    companyUid: string;
    companyName: string;
    /** @format date-time */
    dueDate?: Date | null;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  /** @format date-time */
  publishedAt?: Date;
  /** @format date-time */
  acceptedAt?: Date;
  /** @format date-time */
  activeAt: Date;
  /** @format date-time */
  expiredAt: Date;
  /** @format date-time */
  defaultResponseDueAt?: Date;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
  links?: {
    /** @format contract-actions-enum */
    rel: ContractActions;
    uri?: string | null;
    disabled?: boolean;
  }[];
}

export interface TenderExtendedDTO {
  uid: string;
  hasValidationErrors?: boolean;
  contractFieldsLegs?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  contractFieldsCost?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  contractFieldsTime?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  title: string;
  parentTenderUid?: string;
  company?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  /** @format contract-status-type-enum */
  status: ContractStatusType;
  companiesWithAccess?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  }[];
  contractAccess?: ({
    companyUid: string;
    companyName: string;
    /** @format date-time */
    dueDate?: Date | null;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  } & {
    isDeletable?: boolean;
  })[];
  /** @format date-time */
  publishedAt?: Date;
  /** @format date-time */
  acceptedAt?: Date;
  /** @format date-time */
  activeAt: Date;
  /** @format date-time */
  expiredAt: Date;
  /** @format date-time */
  defaultResponseDueAt?: Date;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
  links?: {
    /** @format contract-actions-enum */
    rel: ContractActions;
    uri?: string | null;
    disabled?: boolean;
  }[];
}

export interface ContractDTO {
  uid: string;
  hasValidationErrors: boolean;
  title: string;
  parentTenderUid?: string;
  parentContractUid: string | null;
  company?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  /** @format contract-status-type-enum */
  status: ContractStatusType;
  isAmendment: boolean;
  contractCode: string | null;
  contractFieldsLegs?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  contractFieldsCost?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  contractFieldsTime?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  amendments?: {
    title: string;
    uid: string;
    hasValidationErrors: boolean;
    parentContractUid?: string;
    contractCode: string | null;
    company?: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    };
    /** @format contract-status-type-enum */
    status: ContractStatusType;
    note?: string;
    contractFieldsLegs?: {
      name: string;
      displayName: string;
      isActive: boolean;
      isRequired: boolean;
      isConfigurable: boolean;
      /** @format contract-field-enum */
      fieldType: ContractFieldType;
      /** @format date-time */
      createdAt?: Date;
      /** @format date-time */
      updatedAt?: Date;
    }[];
    contractFieldsCost?: {
      name: string;
      displayName: string;
      isActive: boolean;
      isRequired: boolean;
      isConfigurable: boolean;
      /** @format contract-field-enum */
      fieldType: ContractFieldType;
      /** @format date-time */
      createdAt?: Date;
      /** @format date-time */
      updatedAt?: Date;
    }[];
    contractFieldsTime?: {
      name: string;
      displayName: string;
      isActive: boolean;
      isRequired: boolean;
      isConfigurable: boolean;
      /** @format contract-field-enum */
      fieldType: ContractFieldType;
      /** @format date-time */
      createdAt?: Date;
      /** @format date-time */
      updatedAt?: Date;
    }[];
    /** @format date-time */
    publishedAt?: Date;
    /** @format date-time */
    acceptedAt?: Date;
    /** @format date-time */
    activeAt: Date;
    /** @format date-time */
    expiredAt: Date;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
    links?: {
      /** @format contract-actions-enum */
      rel: ContractActions;
      uri?: string | null;
      disabled?: boolean;
    }[];
  }[];
  /** @format date-time */
  publishedAt?: Date;
  /** @format date-time */
  acceptedAt?: Date;
  /** @format date-time */
  activeAt: Date;
  /** @format date-time */
  expiredAt: Date;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
  links?: {
    /** @format contract-actions-enum */
    rel: ContractActions;
    uri?: string | null;
    disabled?: boolean;
  }[];
}

export interface CustomContractDTO {
  uid: string;
  title: string;
  company?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  /** @format contract-status-type-enum */
  status: ContractStatusType;
  hasValidationErrors: boolean;
  /** @format date-time */
  publishedAt?: Date;
  /** @format date-time */
  activeAt: Date;
  /** @format date-time */
  expiredAt: Date;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
  links?: {
    /** @format contract-actions-enum */
    rel: ContractActions;
    uri?: string | null;
    disabled?: boolean;
  }[];
}

export interface ContractCodeDTO {
  contractCode: string;
  description?: string;
  carrier?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
  commodityTitle?: string;
  /** @default false */
  fromPortal?: boolean;
}

export interface SimpleContractCodeDTO {
  contractCode: string;
  description?: string;
}

export interface CompanyDTO {
  uid: string;
  /** @format company-type-enum */
  companyType: CompanyType;
  name: string;
  address: string;
  postCode: string;
  city: string;
  country: string;
  website: string;
  phone: string;
  fax?: string | null;
  invoiceAddress: string;
  invoicePostCode: string;
  invoiceCity: string;
  invoiceCountry: string;
  vat: string;
  /** @format date-time */
  deactivatedAt?: Date;
  /** @format date-time */
  archivedAt?: Date;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
  carrierDetails?: {
    accountDebit: string;
    accountCredit: string;
    contact: string;
    scac: string;
    oblLength: number | null;
  };
  memberDetails?: {
    eori: string;
    membershipNumber: string;
    osaAccountNumber: string;
    onmiAccountNumber: string;
    osaMember: boolean;
    ossiMember: boolean;
    affiliateOffice: boolean;
  };
  /** @default false */
  fromPortal?: boolean;
}

export interface SimpleCompanyDTO {
  uid: string;
  name: string;
  /** @format date-time */
  deactivatedAt?: Date;
  /** @format date-time */
  archivedAt?: Date;
}

export interface CommodityDTO {
  title: string;
  description: string;
  /** @default false */
  fromPortal?: boolean;
}

export interface AliasDTO {
  uid: string;
  alias: string;
  /** @format alias-type-enum */
  aliasType: AliasType;
  /** The identifier of the entity the alias is for (entity uid or unlocode) */
  entityPublicId: string;
  /** The string representation of the entity the alias is for */
  knownValue: string;
}

export interface CarrierDetailDTO {
  accountDebit: string;
  accountCredit: string;
  contact: string;
  scac: string;
  oblLength: number | null;
}

export interface MemberDetailDTO {
  eori: string;
  membershipNumber: string;
  osaAccountNumber: string;
  onmiAccountNumber: string;
  osaMember: boolean;
  ossiMember: boolean;
  affiliateOffice: boolean;
}

export interface ExchangeRateDTO {
  currencyCode: string;
  currencyDescription: string;
  baseCurrencyCode?: string | null;
  exchangeRate?: number | null;
  sourceUrl?: string | null;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
}

export type TemplateLegDTO = {
  originCountry: string;
  originPlace: string;
  destinationCountry: string;
  destinationPlace: string;
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  /** @format modality-enum */
  modality: Modality;
  origin?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  destination?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
} & {
  templateLegId: string;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
};

export interface TemplateLegImportErrorDTO {
  originUnlocode: string;
  destinationUnlocode: string;
  /** @format modality-enum */
  modality: Modality;
  tenderResponseUid?: string;
  amendmentUid?: string;
  /** @format date-time */
  importedAt: Date;
}

export interface TemplateLegImportErrorsDTO {
  result: {
    originUnlocode: string;
    destinationUnlocode: string;
    /** @format modality-enum */
    modality: Modality;
    tenderResponseUid?: string;
    amendmentUid?: string;
    /** @format date-time */
    importedAt: Date;
  }[];
}

export interface TemplateLegGroupedBulkUpsertResultDTO {
  result: ({
    originCountry: string;
    originPlace: string;
    destinationCountry: string;
    destinationPlace: string;
    /** @format equipment-type-enum */
    equipmentType: EquipmentType;
    /** @format modality-enum */
    modality: Modality;
    origin?: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    destination?: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
  } & {
    templateLegId: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  })[];
}

export type TenderLegDTO = ({
  originCountry: string;
  originPlace: string;
  destinationCountry: string;
  destinationPlace: string;
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  /** @format modality-enum */
  modality: Modality;
  origin?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  destination?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
} & {
  templateLegId: string;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
}) & {
  /** @format date-time */
  tenderLegCreatedAt?: Date;
  contractId?: string;
  contractUid?: string;
};

export type ContractLegDTO = ({
  originCountry: string;
  originPlace: string;
  destinationCountry: string;
  destinationPlace: string;
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  /** @format modality-enum */
  modality: Modality;
  origin?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  destination?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
} & {
  templateLegId: string;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
}) & {
  groupUuid: string;
  legUuid: string;
  contractCode?: string | null;
  costBaseRate: number;
  costBaseRateCurrency: string;
  timeTransit: number;
  declined: boolean;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  activeAt: Date;
  /** @format date-time */
  expiredAt: Date;
  tradeLaneOrigin?: {
    id: string;
    name: string;
    /** @format unlocodegroup-type-enum */
    type: UnlocodeGroupType;
    description?: string;
  } | null;
  tradeLaneDestination?: {
    id: string;
    name: string;
    /** @format unlocodegroup-type-enum */
    type: UnlocodeGroupType;
    description?: string;
  } | null;
  isFromAnAmendment?: boolean | null;
  isFuture?: boolean | null;
};

export type ContractLegExtendedDTO = {
  legUuid: string;
  groupUuid: string;
} & {
  originCountry: string;
  originPlace: string;
  destinationCountry: string;
  destinationPlace: string;
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  /** @format modality-enum */
  modality: Modality;
  origin?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  destination?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
} & {
  /** @format date-time */
  createdAt?: Date | null;
  /** @format date-time */
  updatedAt?: Date | null;
  /** @format date-time */
  activeAt?: Date | null;
  /** @format date-time */
  expiredAt?: Date | null;
  service?: string | null;
  tradeLane?: {
    origin: string;
    destination: string;
  } | null;
  declined: boolean;
  equipmentShipperOwned?: boolean | null;
  originPortStorageIncluded?: boolean | null;
  destinationPortStorageIncluded?: boolean | null;
  transshipment?: string | null;
  co2Amount?: number | null;
  numberOfSailings?: number | null;
  sailingFrequency?: string | null;
  contractCode?: string | null;
  amendment?: {
    uid: string;
    title: string;
    parentContractUid?: string;
    contractCode: string | null;
    company?: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    };
    note?: string;
    /** @format date-time */
    publishedAt?: Date;
    /** @format date-time */
    acceptedAt?: Date;
    /** @format date-time */
    activeAt: Date;
    /** @format date-time */
    expiredAt: Date;
  };
  shipperComments?: string | null;
  carrierComments?: string | null;
  contractLegFieldsCost?:
    | {
        fieldName: string;
        value: number;
        /**
         * @minLength 3
         * @maxLength 3
         */
        unit: string;
      }[]
    | null;
  contractLegFieldsTime?:
    | {
        fieldName: string;
        value: number;
        /** @format days-type-enum */
        unit: DaysType;
      }[]
    | null;
};

export interface ContractLegEventDTO {
  contractLegEventId: number;
  groupUuid: string | null;
  data: object | null;
  metadata: object | null;
  /** @format contract-leg-event-type-enum */
  type: ContractLegEventType;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  effectiveFrom: Date | null;
  /** @format date-time */
  effectiveUntil: Date | null;
}

export interface ShipmentEventDTO {
  /** @format shipment-event-type-enum */
  type: ShipmentEventType;
  data: Record<string, any>;
  metadata: Record<string, any>;
  /** @format date-time */
  createdAt: Date;
}

export type AmendmentLegChangeDTO = ({
  originCountry: string;
  originPlace: string;
  destinationCountry: string;
  destinationPlace: string;
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  /** @format modality-enum */
  modality: Modality;
  origin?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  destination?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
} & {
  templateLegId: string;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
}) & {
  service?: string;
  /** @format date-time */
  activeAt: Date;
  /** @format date-time */
  expiredAt: Date;
  tradeLane?: {
    origin: string;
    destination: string;
  } | null;
  /** @format amendment-change-type-enum */
  changeType?: AmendmentChangeType;
  changedFields?: {
    fieldName: string;
    newValue: string;
    compareValue: string;
    compareSource?: {
      legUuid?: string | null;
      groupUuid?: string | null;
      contractUid: string;
      /** @format amendment-compare-source-type-enum */
      type?: AmendmentCompareSourceType;
    };
    rowId?: number | null;
  }[];
};

export interface AmendmentLegChangedFieldDTO {
  fieldName: string;
  newValue: string;
  compareValue: string;
  compareSource?: {
    legUuid?: string | null;
    groupUuid?: string | null;
    contractUid: string;
    /** @format amendment-compare-source-type-enum */
    type?: AmendmentCompareSourceType;
  };
  rowId?: number | null;
}

export interface TenderDefaultsDTO {
  /** @format date-time */
  activeAt: Date;
  /** @format date-time */
  expiredAt: Date;
  /** @format date-time */
  defaultResponseDueAt: Date;
  fields?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  surcharges?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  freeTimes?: {
    name: string;
    displayName: string;
    isActive: boolean;
    isRequired: boolean;
    isConfigurable: boolean;
    /** @format contract-field-enum */
    fieldType: ContractFieldType;
    /** @format date-time */
    createdAt?: Date;
    /** @format date-time */
    updatedAt?: Date;
  }[];
  carrierList?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  }[];
}

export interface SearchResultRowDTO {
  /** The unique identifier of the search session */
  searchUuid: string;
  /**
   * The date of the search session
   * @format date-time
   */
  createdAt: Date;
  carrierName: string;
  origin?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  };
  destination?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  };
  /**
   * The date when the latest contract leg becomes active. Null if already active.
   * @format date-time
   */
  activeAt: Date | null;
  /**
   * The date when the earliest contract leg expires.
   * @format date-time
   */
  expiredAt: Date;
  /** The commodity associated with the contract code of the sea freight leg. */
  commodityTitle: string | null;
  /** True if the search result is for a future contract. */
  isFuture: boolean;
  results?: {
    "20ft dry"?: {
      /** The unique identifier of this single search result */
      searchResultUuid: string;
      /** @format equipment-type-enum */
      equipmentType: EquipmentType;
      /** Total sum of the cost of the legs, in the currency of the search */
      costTotal: number;
      /** Total sum of the base rate of the legs, in the currency of the search */
      costBaseRateTotal: number;
      currency: string;
      /** Total sum of the transit time of the legs, in calendar days */
      timeTransitTotal: number;
      /** Transshipment value to show. Will be the value of the transshipment or service field of the sea-freight leg, otherwise the leg count. */
      transshipment: string;
      /** Total sum of CO₂ amount, in kg */
      co2AmountTotal: number | null;
    };
    "40ft dry"?: {
      /** The unique identifier of this single search result */
      searchResultUuid: string;
      /** @format equipment-type-enum */
      equipmentType: EquipmentType;
      /** Total sum of the cost of the legs, in the currency of the search */
      costTotal: number;
      /** Total sum of the base rate of the legs, in the currency of the search */
      costBaseRateTotal: number;
      currency: string;
      /** Total sum of the transit time of the legs, in calendar days */
      timeTransitTotal: number;
      /** Transshipment value to show. Will be the value of the transshipment or service field of the sea-freight leg, otherwise the leg count. */
      transshipment: string;
      /** Total sum of CO₂ amount, in kg */
      co2AmountTotal: number | null;
    };
    "45ft hc dry"?: {
      /** The unique identifier of this single search result */
      searchResultUuid: string;
      /** @format equipment-type-enum */
      equipmentType: EquipmentType;
      /** Total sum of the cost of the legs, in the currency of the search */
      costTotal: number;
      /** Total sum of the base rate of the legs, in the currency of the search */
      costBaseRateTotal: number;
      currency: string;
      /** Total sum of the transit time of the legs, in calendar days */
      timeTransitTotal: number;
      /** Transshipment value to show. Will be the value of the transshipment or service field of the sea-freight leg, otherwise the leg count. */
      transshipment: string;
      /** Total sum of CO₂ amount, in kg */
      co2AmountTotal: number | null;
    };
    "20ft nor"?: {
      /** The unique identifier of this single search result */
      searchResultUuid: string;
      /** @format equipment-type-enum */
      equipmentType: EquipmentType;
      /** Total sum of the cost of the legs, in the currency of the search */
      costTotal: number;
      /** Total sum of the base rate of the legs, in the currency of the search */
      costBaseRateTotal: number;
      currency: string;
      /** Total sum of the transit time of the legs, in calendar days */
      timeTransitTotal: number;
      /** Transshipment value to show. Will be the value of the transshipment or service field of the sea-freight leg, otherwise the leg count. */
      transshipment: string;
      /** Total sum of CO₂ amount, in kg */
      co2AmountTotal: number | null;
    };
    "40ft nor"?: {
      /** The unique identifier of this single search result */
      searchResultUuid: string;
      /** @format equipment-type-enum */
      equipmentType: EquipmentType;
      /** Total sum of the cost of the legs, in the currency of the search */
      costTotal: number;
      /** Total sum of the base rate of the legs, in the currency of the search */
      costBaseRateTotal: number;
      currency: string;
      /** Total sum of the transit time of the legs, in calendar days */
      timeTransitTotal: number;
      /** Transshipment value to show. Will be the value of the transshipment or service field of the sea-freight leg, otherwise the leg count. */
      transshipment: string;
      /** Total sum of CO₂ amount, in kg */
      co2AmountTotal: number | null;
    };
  };
}

export interface SimpleSearchResultDTO {
  /** The unique identifier of this single search result */
  searchResultUuid: string;
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  /** Total sum of the cost of the legs, in the currency of the search */
  costTotal: number;
  /** Total sum of the base rate of the legs, in the currency of the search */
  costBaseRateTotal: number;
  currency: string;
  /** Total sum of the transit time of the legs, in calendar days */
  timeTransitTotal: number;
  /** Transshipment value to show. Will be the value of the transshipment or service field of the sea-freight leg, otherwise the leg count. */
  transshipment: string;
  /** Total sum of CO₂ amount, in kg */
  co2AmountTotal: number | null;
}

export interface SearchResultDTO {
  carrier?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  origin?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  };
  destination?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  };
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  costTotal: number;
  costBaseRateTotal: number;
  currency: string;
  timeTransitTotal: number;
  /** Transshipment value to show. Will be the value of the transshipment or service field of the sea-freight leg, otherwise the leg count. */
  transshipment: string;
  /** CO₂ amount in kg */
  co2AmountTotal: number | null;
  /** The shipping service of the sea-freight leg. */
  service: string | null;
  /** The contract code of the sea-freight leg or its contract. */
  contractCode: string | null;
  /** The commodity associated with the contract code of the sea freight leg. */
  commodityTitle: string | null;
  tradeLane: {
    origin: string;
    destination: string;
  } | null;
  /**
   * The date when the latest contract leg becomes active. Null if already active.
   * @format date-time
   */
  activeAt: Date | null;
  /**
   * The date when the earliest contract leg expires.
   * @format date-time
   */
  expiredAt: Date | null;
  links?: {
    /** @format contract-actions-enum */
    rel: ContractActions;
    uri?: string | null;
    disabled?: boolean;
  }[];
  legs?: ({
    legUuid: string;
    groupUuid: string;
  } & {
    originCountry: string;
    originPlace: string;
    destinationCountry: string;
    destinationPlace: string;
    /** @format equipment-type-enum */
    equipmentType: EquipmentType;
    /** @format modality-enum */
    modality: Modality;
    origin?: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    destination?: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
  } & {
    /** @format date-time */
    createdAt?: Date | null;
    /** @format date-time */
    updatedAt?: Date | null;
    /** @format date-time */
    activeAt?: Date | null;
    /** @format date-time */
    expiredAt?: Date | null;
    service?: string | null;
    tradeLane?: {
      origin: string;
      destination: string;
    } | null;
    declined: boolean;
    equipmentShipperOwned?: boolean | null;
    originPortStorageIncluded?: boolean | null;
    destinationPortStorageIncluded?: boolean | null;
    transshipment?: string | null;
    co2Amount?: number | null;
    numberOfSailings?: number | null;
    sailingFrequency?: string | null;
    contractCode?: string | null;
    shipperComments?: string | null;
    carrierComments?: string | null;
    contractLegFieldsCost: ({
      fieldName: string;
      value: number;
      /**
       * @minLength 3
       * @maxLength 3
       */
      unit: string;
    } & {
      /** @format cost-calculation-category-enum */
      category: CostCalculationCategory;
      originalValue?: number;
      /**
       * @minLength 3
       * @maxLength 3
       */
      originalUnit?: string;
      exchangeRate?: number;
    })[];
    contractLegFieldsTime: ({
      fieldName: string;
      value: number;
      /** @format days-type-enum */
      unit: DaysType;
    } & {
      /** @format time-calculation-category-enum */
      category: TimeCalculationCategory;
    })[];
    contract?: {
      uid: string;
      title: string;
      contractCode: string | null;
      isAmendment: boolean;
      /**
       * The date when the contract was last updated or amended.
       * @format date-time
       */
      updatedAt: Date;
    };
  })[];
}

export type SearchLegDTO = {
  legUuid: string;
  groupUuid: string;
} & {
  originCountry: string;
  originPlace: string;
  destinationCountry: string;
  destinationPlace: string;
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  /** @format modality-enum */
  modality: Modality;
  origin?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  destination?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
} & {
  /** @format date-time */
  createdAt?: Date | null;
  /** @format date-time */
  updatedAt?: Date | null;
  /** @format date-time */
  activeAt?: Date | null;
  /** @format date-time */
  expiredAt?: Date | null;
  service?: string | null;
  tradeLane?: {
    origin: string;
    destination: string;
  } | null;
  declined: boolean;
  equipmentShipperOwned?: boolean | null;
  originPortStorageIncluded?: boolean | null;
  destinationPortStorageIncluded?: boolean | null;
  transshipment?: string | null;
  co2Amount?: number | null;
  numberOfSailings?: number | null;
  sailingFrequency?: string | null;
  contractCode?: string | null;
  shipperComments?: string | null;
  carrierComments?: string | null;
  contractLegFieldsCost: ({
    fieldName: string;
    value: number;
    /**
     * @minLength 3
     * @maxLength 3
     */
    unit: string;
  } & {
    /** @format cost-calculation-category-enum */
    category: CostCalculationCategory;
    originalValue?: number;
    /**
     * @minLength 3
     * @maxLength 3
     */
    originalUnit?: string;
    exchangeRate?: number;
  })[];
  contractLegFieldsTime: ({
    fieldName: string;
    value: number;
    /** @format days-type-enum */
    unit: DaysType;
  } & {
    /** @format time-calculation-category-enum */
    category: TimeCalculationCategory;
  })[];
  contract?: {
    uid: string;
    title: string;
    contractCode: string | null;
    isAmendment: boolean;
    /**
     * The date when the contract was last updated or amended.
     * @format date-time
     */
    updatedAt: Date;
  };
};

export type BenchmarkLegDTO = {
  originCountry: string;
  originPlace: string;
  destinationCountry: string;
  destinationPlace: string;
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  /** @format modality-enum */
  modality: Modality;
  origin?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  destination?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
} & {
  originLocation: string;
  destinationLocation: string;
  destinationTradeRegion: string;
  costLowestAmount: number;
  costBenchmarkAmount: number;
  costBenchmarkCurrency: string;
  [key: string]: any;
};

export interface SearchSessionDTO {
  /** The unique identifier of the search session */
  searchUuid: string;
  /**
   * The date of the search session
   * @format date-time
   */
  createdAt: Date;
  /** Optional warning text to show to the user */
  warning?: string;
}

export type TradeLaneDTO = {
  origin: string;
  destination: string;
} | null;

export interface ProgressDTO {
  progress?: number;
  hasValidationErrors?: boolean;
}

export interface ValidationResultDTO {
  errorRow?: number | null;
  errorDescription?: string;
}

export interface AliasQueryFilter {
  aliasType?: AliasType[] | null;
  alias?: string[] | null;
  entityPublicId?: string[] | null;
}

export interface UnlocodeQueryFilter {
  searchTerm?: string[];
  countryCode?: string[] | null;
  name?: string[] | null;
  placeCode?: string[] | null;
  plainName?: string[] | null;
  status?: string[] | null;
  subDivision?: string[] | null;
  IATA?: string[] | null;
  unlocode?: string[] | null;
  unlocodeGroupId?: string[] | null;
  createdAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  updatedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  coordinates?: QueryCoordinate[][] | null;
}

export interface UnlocodeGroupQueryFilter {
  id?: string[] | null;
  name?: string[] | null;
  type?: string[] | null;
  description?: string[] | null;
}

export interface UserLogQueryFilter {
  ipAddress?: string[] | null;
  userEmail?: string[] | null;
  /** Filter by company UIDs */
  companyUid?: string[] | null;
  /** Filter by company name (partial match) */
  companyName?: string[] | null;
  /** Filter by user full name (partial match) */
  fullName?: string[] | null;
  /** Filter by blocked status. Use false for active users, true for blocked users. */
  isBlocked?: (string | boolean)[] | null;
  createdAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
}

export interface PortalQueryFilter {
  name?: string[] | null;
  adminEmail?: string[] | null;
  createdAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  updatedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
}

export interface ExchangeRateQueryFilter {
  currencyCode?: string[] | null;
  currencyDescription?: string[] | null;
  exchangeRate?:
    | {
        from?: number;
        to?: number;
      }[]
    | null;
  createdAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  updatedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  sourceUrl?: string[] | null;
}

export type TenderResponseQueryFilter = ({
  templateLegId?: string[] | null;
  originUnlocodeGroup?: string[] | null;
  destinationUnlocodeGroup?: string[] | null;
  originUnlocode?: string[] | null;
  destinationUnlocode?: string[] | null;
  originCountry?: string[] | null;
  originPlace?: string[] | null;
  destinationCountry?: string[] | null;
  destinationPlace?: string[] | null;
  equipmentType?: EquipmentType[] | null;
  modality?: Modality[] | null;
  createdAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  updatedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
} & {
  status?: ContractLegStatus[] | null;
  changeType?: AmendmentChangeType[] | null;
  service?: string[] | null;
  tradeLane?:
    | {
        origin?: string;
        destination?: string;
      }[]
    | null;
  groupUuid?: string[] | null;
  legUuid?: string[] | null;
  contractId?: string[] | null;
  costBaseRate?: {
    from?: number | null;
    to?: number | null;
  }[];
  costBaseRateCurrency?: string[] | null;
  timeTransit?: {
    from?: number | null;
    to?: number | null;
  }[];
  activeAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  expiredAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  /** @format contract-leg-grouping-enum */
  legGrouping?: ContractLegQueryFilterLegGrouping;
}) & {
  declined?: (string | boolean)[] | null;
};

export interface UserQueryFilter {
  uid?: string[] | null;
  firstName?: string[] | null;
  lastName?: string[] | null;
  phone?: string[] | null;
  language?: string[] | null;
  country?: string[] | null;
  companyUid?: string[] | null;
  isSuperAdmin?: (string | boolean)[] | null;
  isBlocked?: (string | boolean)[] | null;
  email?: string[] | null;
  createdAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  updatedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  fullName?: string[] | null;
}

export interface CompanyQueryFilter {
  uid?: string[] | null;
  name?: string[] | null;
  companyType?: CompanyType[] | null;
  address?: string[] | null;
  postCode?: string[] | null;
  city?: string[] | null;
  country?: string[] | null;
  website?: string[] | null;
  phone?: string[] | null;
  fax?: string[] | null;
  invoiceAddress?: string[] | null;
  invoicePostCode?: string[] | null;
  invoiceCity?: string[] | null;
  invoiceCountry?: string[] | null;
  isActive?: (string | boolean)[] | null;
  vat?: string[] | null;
  deactivatedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  archivedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  createdAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  updatedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  carrierDetails?: (boolean | string)[] | null;
  memberDetails?: (boolean | string)[] | null;
  fromPortal?: boolean[] | null;
}

export interface NewsQueryFilter {
  searchTerm?: string[] | null;
  publishedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
}

export interface TemplateLegQueryFilter {
  templateLegId?: string[] | null;
  originUnlocodeGroup?: string[] | null;
  destinationUnlocodeGroup?: string[] | null;
  originUnlocode?: string[] | null;
  destinationUnlocode?: string[] | null;
  originCountry?: string[] | null;
  originPlace?: string[] | null;
  destinationCountry?: string[] | null;
  destinationPlace?: string[] | null;
  equipmentType?: EquipmentType[] | null;
  modality?: Modality[] | null;
  createdAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  updatedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
}

export interface LocationsQueryFilter {
  terminus?: TerminusType[] | null;
  locationType?: LocationType[] | null;
  values?: string[] | null;
}

export interface AliasReverseQueryFilter {
  aliasType?: AliasType[] | null;
  entityPublicId?: string[] | null;
}

export type ContractLegQueryFilter = {
  templateLegId?: string[] | null;
  originUnlocodeGroup?: string[] | null;
  destinationUnlocodeGroup?: string[] | null;
  originUnlocode?: string[] | null;
  destinationUnlocode?: string[] | null;
  originCountry?: string[] | null;
  originPlace?: string[] | null;
  destinationCountry?: string[] | null;
  destinationPlace?: string[] | null;
  equipmentType?: EquipmentType[] | null;
  modality?: Modality[] | null;
  createdAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  updatedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
} & {
  status?: ContractLegStatus[] | null;
  changeType?: AmendmentChangeType[] | null;
  service?: string[] | null;
  tradeLane?:
    | {
        origin?: string;
        destination?: string;
      }[]
    | null;
  groupUuid?: string[] | null;
  legUuid?: string[] | null;
  contractId?: string[] | null;
  costBaseRate?: {
    from?: number | null;
    to?: number | null;
  }[];
  costBaseRateCurrency?: string[] | null;
  timeTransit?: {
    from?: number | null;
    to?: number | null;
  }[];
  activeAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  expiredAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  /** @format contract-leg-grouping-enum */
  legGrouping?: ContractLegQueryFilterLegGrouping;
};

export interface ContractQueryFilter {
  title?: string[] | null;
  createdAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  activeAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  expiredAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  company?: string[] | null;
  acceptedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  status?: ContractStatusType[] | null;
  contractYear?: (number | string)[] | null;
}

export interface ContractCodeQueryFilter {
  contractCode?: string[] | null;
}

export interface TenderQueryFilter {
  uid?: string[] | null;
  title?: string[] | null;
  createdAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  updatedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  parentTenderUid?: string[] | null;
  company?: string[] | null;
  publishedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  acceptedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  activeAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  expiredAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  defaultResponseDueAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  status?: ContractStatusType[] | null;
  activeAtExpiredAtRange?: {
    activeAt?: {
      /** @format date-time */
      from?: Date;
      /** @format date-time */
      to?: Date;
    } | null;
    expiredAt?: {
      /** @format date-time */
      from?: Date;
      /** @format date-time */
      to?: Date;
    } | null;
  }[];
}

export interface SearchResultQueryFilter {
  carrierUid?: string[] | null;
  equipmentType?: EquipmentType[] | null;
  commodityTitle?: string[] | null;
}

export interface ImportShipmentsQueryFilter {
  obl?: string[] | null;
  originUnlocode?: string[] | null;
  destinationUnlocode?: string[] | null;
  contractCode?: string[] | null;
  memberReference?: string[] | null;
  carrierBookingNumber?: string[] | null;
  carrierUid?: string[] | null;
  reportTitle?: string[] | null;
  shippedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  memberUid?: string[] | null;
  status?: ShipmentStatus[] | null;
  /** Import UUIDs to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
  importUuid?: string[] | null;
}

export interface ContractLink {
  /** @format contract-actions-enum */
  rel: ContractActions;
  uri?: string | null;
  disabled?: boolean;
}

export interface NewsLink {
  /** @format news-actions-enum */
  rel: string;
  uri?: string | null;
  disabled?: boolean;
}

export interface TenderContractYearsDTO {
  years: number[];
}

export interface TenderContractStatusesDTO {
  statuses: ContractStatusType[];
}

export interface UserPrivilegesDTO {
  privileges?: string[];
}

export interface TemplateLegEquipmentTypesDTO {
  equipmentTypes?: EquipmentType[];
}

export interface TemplateLegModalitiesDTO {
  modalities?: Modality[];
}

export interface ContractLegUuid {
  legUuid: string;
  groupUuid: string;
}

export interface TimeFieldDTO {
  fieldName: string;
  value: number;
  /** @format days-type-enum */
  unit: DaysType;
}

export type ExtendedTimeFieldDTO = {
  fieldName: string;
  value: number;
  /** @format days-type-enum */
  unit: DaysType;
} & {
  /** @format time-calculation-category-enum */
  category: TimeCalculationCategory;
};

export interface CostFieldDTO {
  fieldName: string;
  value: number;
  /**
   * @minLength 3
   * @maxLength 3
   */
  unit: string;
}

export type ExtendedCostFieldDTO = {
  fieldName: string;
  value: number;
  /**
   * @minLength 3
   * @maxLength 3
   */
  unit: string;
} & {
  /** @format cost-calculation-category-enum */
  category: CostCalculationCategory;
  originalValue?: number;
  /**
   * @minLength 3
   * @maxLength 3
   */
  originalUnit?: string;
  exchangeRate?: number;
};

export interface NewsDTO {
  title: string;
  slug: string;
  introText: string;
  content?: object;
  syncPortal: boolean;
  /** @format date-time */
  publishedAt?: Date;
  /** @format date-time */
  createdAt?: Date | null;
  /** @format date-time */
  updatedAt?: Date | null;
  accessGroups?: UserGroupName[];
  files?: ({
    fileName?: string;
    /** @format file-types-enum */
    fileType?: FileTypes;
    path?: string;
    downloadLink?: string;
  } | null)[];
  imageLink?: string | null;
  links?: {
    /** @format news-actions-enum */
    rel: string;
    uri?: string | null;
    disabled?: boolean;
  }[];
}

export interface FileDTO {
  fileName?: string;
  /** @format file-types-enum */
  fileType?: FileTypes;
  path?: string;
  downloadLink?: string;
}

export interface LocationDTO {
  filterValue?: string;
  /** @format location-type-enum */
  type?: LocationType;
  unlocode?: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  unlocodeGroup?: {
    id: string;
    name: string;
    /** @format unlocodegroup-type-enum */
    type: UnlocodeGroupType;
    description?: string;
  } | null;
  /** @format terminus-type-enum */
  terminus?: TerminusType;
}

export interface PortalDTO {
  name: string;
  company?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  adminEmail: string;
  publicEmail: string;
  headerLogoPublicUrl: string;
  logoPublicUrl: string;
  coverImagePublicUrl: string;
  domain: string;
  address: string;
  disclaimer: string;
  region: string;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
}

export interface TierDTO {
  customer?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  /** @format tier-type-enum */
  tier?: TierTypes;
}

export interface PortalCostTypeDTO {
  /** @format portal-cost-type-enum */
  costType?: PortalCostTypes;
  /** @format apply-type-enum */
  apply?: ApplyTypes;
}

export interface TierCostDTO {
  costType?: {
    /** @format portal-cost-type-enum */
    costType?: PortalCostTypes;
    /** @format apply-type-enum */
    apply?: ApplyTypes;
  };
  amount?: number;
  currency?: string;
  /** @format equipment-type-enum */
  equipmentType?: EquipmentType;
  /** @format date-time */
  activeAt?: Date | null;
  fromGroup?: {
    id: string;
    name: string;
    /** @format unlocodegroup-type-enum */
    type: UnlocodeGroupType;
    description?: string;
  };
  toGroup?: {
    id: string;
    name: string;
    /** @format unlocodegroup-type-enum */
    type: UnlocodeGroupType;
    description?: string;
  };
}

export interface CustomerAllowedCarrierDTO {
  carrier?: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  isAllowed?: boolean;
}

export interface NotificationSubscriptionDTO {
  notificationType: {
    /** @format notification-type-enum */
    type: NotificationTypes;
  };
  isSubscribed: boolean;
  asDigest: boolean;
}

export interface UserPreferencesDTO {
  /** @format date-format-enum */
  dateFormat: DateFormats;
  /** @format time-format-enum */
  timeFormat: TimeFormats;
  /** @format number-format-enum */
  numberFormat: NumberFormats;
  /**
   * @minLength 3
   * @maxLength 3
   */
  currency: string;
  equipmentTypes: EquipmentType[];
}

export interface UserLogDTO {
  ipAddress: string;
  userEmail: string;
  location?: string | null;
  user?: {
    id: string;
    uid: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string;
    language?: string;
    country?: string | null;
    phone?: string | null;
    isBlocked: boolean;
    isSuperAdmin: boolean;
    invitationConfirmed: boolean;
    groups?: UserGroupName[];
    company?: {
      uid: string;
      /** @format company-type-enum */
      companyType: CompanyType;
      name: string;
      address: string;
      postCode: string;
      city: string;
      country: string;
      website: string;
      phone: string;
      fax?: string | null;
      invoiceAddress: string;
      invoicePostCode: string;
      invoiceCity: string;
      invoiceCountry: string;
      vat: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
      carrierDetails?: {
        accountDebit: string;
        accountCredit: string;
        contact: string;
        scac: string;
        oblLength: number | null;
      };
      memberDetails?: {
        eori: string;
        membershipNumber: string;
        osaAccountNumber: string;
        onmiAccountNumber: string;
        osaMember: boolean;
        ossiMember: boolean;
        affiliateOffice: boolean;
      };
      /** @default false */
      fromPortal?: boolean;
    };
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  };
  /** @format date-time */
  createdAt: Date;
}

export interface ReportDTO {
  reportUuid: string;
  title: string;
  /** @format report-type-enum */
  type: ReportType;
  company: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  } | null;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
}

export interface ShipmentDTO {
  obl: string;
  teu: number;
  /** @format date-time */
  shippedAt: Date;
  memberCompany: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  } | null;
  carrierCompany: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  } | null;
  originUnlocode: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  destinationUnlocode: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  contractCodeEntity: {
    contractCode: string;
    description?: string;
  } | null;
  note?: string | null;
  carrierBookingNumber?: string | null;
  memberReference?: string | null;
  containers: string[];
  /** @format reported-by-enum */
  reportedBy: ReportedBy;
  /** @format date-time */
  createdAt: Date;
}

export interface ImportShipmentIssues {
  errors?: {
    memberUid?: string;
    carrierUid?: string;
    originLocation?: string;
    destinationLocation?: string;
    contractCode?: string;
    scac?: string;
  };
  warnings?: {
    obl?: string;
    contractCode?: string;
  };
}

export interface ShipmentImportPayloadDTO {
  obl: string;
  teu: number;
  /** @format date-time */
  shippedAt: Date;
  memberCompanyUid: string;
  carrierCompanyUid: string;
  originUnlocode: string;
  destinationUnlocode: string;
  contractCode: string;
  note: string | null;
  carrierBookingNumber: string | null;
  memberReference: string | null;
  containers: string[];
  /** @format reported-by-enum */
  reportedBy: ReportedBy;
}

export type ImportShipmentDTO = {
  obl: string;
  teu: number;
  /** @format date-time */
  shippedAt: Date;
  memberCompany: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  } | null;
  carrierCompany: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  } | null;
  originUnlocode: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  destinationUnlocode: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  contractCodeEntity: {
    contractCode: string;
    description?: string;
  } | null;
  note?: string | null;
  carrierBookingNumber?: string | null;
  memberReference?: string | null;
  containers: string[];
  /** @format reported-by-enum */
  reportedBy: ReportedBy;
  /** @format date-time */
  createdAt: Date;
} & {
  report?: {
    reportUuid: string;
    title: string;
    /** @format report-type-enum */
    type: ReportType;
    company: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  };
  importUuid: string | null;
  originLocation: string | null;
  destinationLocation: string | null;
  memberName: string | null;
  carrierName: string | null;
  contractCode: string | null;
  issues?: {
    errors?: {
      memberUid?: string;
      carrierUid?: string;
      originLocation?: string;
      destinationLocation?: string;
      contractCode?: string;
      scac?: string;
    };
    warnings?: {
      obl?: string;
      contractCode?: string;
    };
  } | null;
};

export interface ImportShipmentReferenceDTO {
  importUuid: string | null;
  obl: string;
}

export interface MergeImportDTO {
  importUuid: string;
  duplicates: ({
    obl: string;
    teu: number;
    /** @format date-time */
    shippedAt: Date;
    memberCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    carrierCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    originUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    destinationUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    contractCodeEntity: {
      contractCode: string;
      description?: string;
    } | null;
    note?: string | null;
    carrierBookingNumber?: string | null;
    memberReference?: string | null;
    containers: string[];
    /** @format reported-by-enum */
    reportedBy: ReportedBy;
    /** @format date-time */
    createdAt: Date;
  } & {
    report?: {
      reportUuid: string;
      title: string;
      /** @format report-type-enum */
      type: ReportType;
      company: {
        uid: string;
        name: string;
        /** @format date-time */
        deactivatedAt?: Date;
        /** @format date-time */
        archivedAt?: Date;
      } | null;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    };
    importUuid: string | null;
    originLocation: string | null;
    destinationLocation: string | null;
    memberName: string | null;
    carrierName: string | null;
    contractCode: string | null;
    issues?: {
      errors?: {
        memberUid?: string;
        carrierUid?: string;
        originLocation?: string;
        destinationLocation?: string;
        contractCode?: string;
        scac?: string;
      };
      warnings?: {
        obl?: string;
        contractCode?: string;
      };
    } | null;
  })[];
  mergeProposal: {
    obl: string;
    teu: number;
    /** @format date-time */
    shippedAt: Date;
    memberCompanyUid: string;
    carrierCompanyUid: string;
    originUnlocode: string;
    destinationUnlocode: string;
    contractCode: string;
    note: string | null;
    carrierBookingNumber: string | null;
    memberReference: string | null;
    containers: string[];
    /** @format reported-by-enum */
    reportedBy: ReportedBy;
  };
}

export interface MergeShipmentDTO {
  importUuid: string;
  duplicates: {
    /** @format uuid */
    activeShipmentUuid: string;
    obl: string;
    teu: number;
    /** @format date-time */
    shippedAt: Date;
    memberCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    carrierCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    originUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    destinationUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    contractCode: {
      contractCode: string;
      description?: string;
    } | null;
    note: string | null;
    carrierBookingNumber: string | null;
    memberReference: string | null;
    containers: string[];
    /** @format reported-by-enum */
    reportedBy: ReportedBy;
    canBeInvoiced: boolean;
    /** Shipment report UUIDs this OBL has appeared in */
    reportUuids: string[];
    /** Report UUID and title per linked report; populated on invoice/credit create-list only. */
    reports?: {
      /** @format uuid */
      reportUuid: string;
      /** Report title from shipmentReports; empty when the report row is missing. */
      title: string;
    }[];
    financeStatus: {
      /** Net TEU currently considered invoiced (invoiced - credited) */
      teuInvoiced: number;
      amountInvoiced: number;
      amountPaid?: number | null;
      teuVidBatched?: number | null;
      amountVidBatched?: number | null;
      teuTopUpVidBatched?: number | null;
      amountTopUpVidBatched?: number | null;
      /** List of invoices applied to this OBL */
      invoices?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      /** List of credits applied to this OBL */
      credits?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      vidBatches?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      topUpVidBatches?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
    };
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  }[];
  mergeProposal: {
    obl: string;
    teu: number;
    /** @format date-time */
    shippedAt: Date;
    memberCompanyUid: string;
    carrierCompanyUid: string;
    originUnlocode: string;
    destinationUnlocode: string;
    contractCode: string;
    note: string | null;
    carrierBookingNumber: string | null;
    memberReference: string | null;
    containers: string[];
    /** @format reported-by-enum */
    reportedBy: ReportedBy;
  };
}

export interface ProcessImportShipmentsResultDTO {
  duplicatesDiscarded: {
    importUuid: string | null;
    obl: string;
  }[];
  autoMerged: {
    importUuid: string | null;
    obl: string;
  }[];
  processed?: {
    importUuid: string | null;
    obl: string;
  }[];
  importDuplicates: {
    importUuid: string;
    duplicates: ({
      obl: string;
      teu: number;
      /** @format date-time */
      shippedAt: Date;
      memberCompany: {
        uid: string;
        name: string;
        /** @format date-time */
        deactivatedAt?: Date;
        /** @format date-time */
        archivedAt?: Date;
      } | null;
      carrierCompany: {
        uid: string;
        name: string;
        /** @format date-time */
        deactivatedAt?: Date;
        /** @format date-time */
        archivedAt?: Date;
      } | null;
      originUnlocode: {
        unlocode: string;
        countryCode: string;
        placeCode: string;
        name: string;
        plainName: string;
        coordinates?: {
          long?: number;
          lat?: number;
        };
        subDivision: string;
        status: string;
        sourceUpdated: string;
        IATA: string;
        /** @format date-time */
        createdAt: Date;
        /** @format date-time */
        updatedAt: Date;
      } | null;
      destinationUnlocode: {
        unlocode: string;
        countryCode: string;
        placeCode: string;
        name: string;
        plainName: string;
        coordinates?: {
          long?: number;
          lat?: number;
        };
        subDivision: string;
        status: string;
        sourceUpdated: string;
        IATA: string;
        /** @format date-time */
        createdAt: Date;
        /** @format date-time */
        updatedAt: Date;
      } | null;
      contractCodeEntity: {
        contractCode: string;
        description?: string;
      } | null;
      note?: string | null;
      carrierBookingNumber?: string | null;
      memberReference?: string | null;
      containers: string[];
      /** @format reported-by-enum */
      reportedBy: ReportedBy;
      /** @format date-time */
      createdAt: Date;
    } & {
      report?: {
        reportUuid: string;
        title: string;
        /** @format report-type-enum */
        type: ReportType;
        company: {
          uid: string;
          name: string;
          /** @format date-time */
          deactivatedAt?: Date;
          /** @format date-time */
          archivedAt?: Date;
        } | null;
        /** @format date-time */
        createdAt: Date;
        /** @format date-time */
        updatedAt: Date;
      };
      importUuid: string | null;
      originLocation: string | null;
      destinationLocation: string | null;
      memberName: string | null;
      carrierName: string | null;
      contractCode: string | null;
      issues?: {
        errors?: {
          memberUid?: string;
          carrierUid?: string;
          originLocation?: string;
          destinationLocation?: string;
          contractCode?: string;
          scac?: string;
        };
        warnings?: {
          obl?: string;
          contractCode?: string;
        };
      } | null;
    })[];
    mergeProposal: {
      obl: string;
      teu: number;
      /** @format date-time */
      shippedAt: Date;
      memberCompanyUid: string;
      carrierCompanyUid: string;
      originUnlocode: string;
      destinationUnlocode: string;
      contractCode: string;
      note: string | null;
      carrierBookingNumber: string | null;
      memberReference: string | null;
      containers: string[];
      /** @format reported-by-enum */
      reportedBy: ReportedBy;
    };
  }[];
  shipmentDuplicates: {
    importUuid: string;
    duplicates: {
      /** @format uuid */
      activeShipmentUuid: string;
      obl: string;
      teu: number;
      /** @format date-time */
      shippedAt: Date;
      memberCompany: {
        uid: string;
        name: string;
        /** @format date-time */
        deactivatedAt?: Date;
        /** @format date-time */
        archivedAt?: Date;
      } | null;
      carrierCompany: {
        uid: string;
        name: string;
        /** @format date-time */
        deactivatedAt?: Date;
        /** @format date-time */
        archivedAt?: Date;
      } | null;
      originUnlocode: {
        unlocode: string;
        countryCode: string;
        placeCode: string;
        name: string;
        plainName: string;
        coordinates?: {
          long?: number;
          lat?: number;
        };
        subDivision: string;
        status: string;
        sourceUpdated: string;
        IATA: string;
        /** @format date-time */
        createdAt: Date;
        /** @format date-time */
        updatedAt: Date;
      } | null;
      destinationUnlocode: {
        unlocode: string;
        countryCode: string;
        placeCode: string;
        name: string;
        plainName: string;
        coordinates?: {
          long?: number;
          lat?: number;
        };
        subDivision: string;
        status: string;
        sourceUpdated: string;
        IATA: string;
        /** @format date-time */
        createdAt: Date;
        /** @format date-time */
        updatedAt: Date;
      } | null;
      contractCode: {
        contractCode: string;
        description?: string;
      } | null;
      note: string | null;
      carrierBookingNumber: string | null;
      memberReference: string | null;
      containers: string[];
      /** @format reported-by-enum */
      reportedBy: ReportedBy;
      canBeInvoiced: boolean;
      /** Shipment report UUIDs this OBL has appeared in */
      reportUuids: string[];
      /** Report UUID and title per linked report; populated on invoice/credit create-list only. */
      reports?: {
        /** @format uuid */
        reportUuid: string;
        /** Report title from shipmentReports; empty when the report row is missing. */
        title: string;
      }[];
      financeStatus: {
        /** Net TEU currently considered invoiced (invoiced - credited) */
        teuInvoiced: number;
        amountInvoiced: number;
        amountPaid?: number | null;
        teuVidBatched?: number | null;
        amountVidBatched?: number | null;
        teuTopUpVidBatched?: number | null;
        amountTopUpVidBatched?: number | null;
        /** List of invoices applied to this OBL */
        invoices?:
          | {
              /** @format uuid */
              uid: string;
              teu: number;
              amount: number;
              companyUid: string;
              /** @format date-time */
              createdAt: Date;
              isCorrection?: boolean;
              /** @format date-time */
              paidAt?: Date;
            }[]
          | null;
        /** List of credits applied to this OBL */
        credits?:
          | {
              /** @format uuid */
              uid: string;
              teu: number;
              amount: number;
              companyUid: string;
              /** @format date-time */
              createdAt: Date;
              isCorrection?: boolean;
              /** @format date-time */
              paidAt?: Date;
            }[]
          | null;
        vidBatches?:
          | {
              /** @format uuid */
              uid: string;
              teu: number;
              amount: number;
              companyUid: string;
              /** @format date-time */
              createdAt: Date;
              isCorrection?: boolean;
              /** @format date-time */
              paidAt?: Date;
            }[]
          | null;
        topUpVidBatches?:
          | {
              /** @format uuid */
              uid: string;
              teu: number;
              amount: number;
              companyUid: string;
              /** @format date-time */
              createdAt: Date;
              isCorrection?: boolean;
              /** @format date-time */
              paidAt?: Date;
            }[]
          | null;
      };
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    }[];
    mergeProposal: {
      obl: string;
      teu: number;
      /** @format date-time */
      shippedAt: Date;
      memberCompanyUid: string;
      carrierCompanyUid: string;
      originUnlocode: string;
      destinationUnlocode: string;
      contractCode: string;
      note: string | null;
      carrierBookingNumber: string | null;
      memberReference: string | null;
      containers: string[];
      /** @format reported-by-enum */
      reportedBy: ReportedBy;
    };
  }[];
  /** True when the imports were processed, but updating the shipment overviews is deferred to the next event loop. */
  deferred?: boolean;
}

export interface RebuildOblReadModelsResultDTO {
  obl: string;
  eventsProcessed: number;
  firstEventId: number;
  lastEventId: number;
}

/** Hydrated shipment report reference (title loaded at read time; not stored on the active shipment read model). */
export interface ActiveShipmentReportRefDTO {
  /** @format uuid */
  reportUuid: string;
  /** Report title from shipmentReports; empty when the report row is missing. */
  title: string;
}

export interface ActiveShipmentDTO {
  /** @format uuid */
  activeShipmentUuid: string;
  obl: string;
  teu: number;
  /** @format date-time */
  shippedAt: Date;
  memberCompany: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  } | null;
  carrierCompany: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  } | null;
  originUnlocode: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  destinationUnlocode: {
    unlocode: string;
    countryCode: string;
    placeCode: string;
    name: string;
    plainName: string;
    coordinates?: {
      long?: number;
      lat?: number;
    };
    subDivision: string;
    status: string;
    sourceUpdated: string;
    IATA: string;
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  } | null;
  contractCode: {
    contractCode: string;
    description?: string;
  } | null;
  note: string | null;
  carrierBookingNumber: string | null;
  memberReference: string | null;
  containers: string[];
  /** @format reported-by-enum */
  reportedBy: ReportedBy;
  canBeInvoiced: boolean;
  /** Shipment report UUIDs this OBL has appeared in */
  reportUuids: string[];
  /** Report UUID and title per linked report; populated on invoice/credit create-list only. */
  reports?: {
    /** @format uuid */
    reportUuid: string;
    /** Report title from shipmentReports; empty when the report row is missing. */
    title: string;
  }[];
  financeStatus: {
    /** Net TEU currently considered invoiced (invoiced - credited) */
    teuInvoiced: number;
    amountInvoiced: number;
    amountPaid?: number | null;
    teuVidBatched?: number | null;
    amountVidBatched?: number | null;
    teuTopUpVidBatched?: number | null;
    amountTopUpVidBatched?: number | null;
    /** List of invoices applied to this OBL */
    invoices?:
      | {
          /** @format uuid */
          uid: string;
          teu: number;
          amount: number;
          companyUid: string;
          /** @format date-time */
          createdAt: Date;
          isCorrection?: boolean;
          /** @format date-time */
          paidAt?: Date;
        }[]
      | null;
    /** List of credits applied to this OBL */
    credits?:
      | {
          /** @format uuid */
          uid: string;
          teu: number;
          amount: number;
          companyUid: string;
          /** @format date-time */
          createdAt: Date;
          isCorrection?: boolean;
          /** @format date-time */
          paidAt?: Date;
        }[]
      | null;
    vidBatches?:
      | {
          /** @format uuid */
          uid: string;
          teu: number;
          amount: number;
          companyUid: string;
          /** @format date-time */
          createdAt: Date;
          isCorrection?: boolean;
          /** @format date-time */
          paidAt?: Date;
        }[]
      | null;
    topUpVidBatches?:
      | {
          /** @format uuid */
          uid: string;
          teu: number;
          amount: number;
          companyUid: string;
          /** @format date-time */
          createdAt: Date;
          isCorrection?: boolean;
          /** @format date-time */
          paidAt?: Date;
        }[]
      | null;
  };
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
}

/** Represents an Active Shipment eligible for credit, showing the creditable TEU and related invoice. */
export interface CreditableShipmentDTO {
  /** The OBL of the shipment. */
  obl: string;
  /** The full ActiveShipment details. */
  shipment: {
    /** @format uuid */
    activeShipmentUuid: string;
    obl: string;
    teu: number;
    /** @format date-time */
    shippedAt: Date;
    memberCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    carrierCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    originUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    destinationUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    contractCode: {
      contractCode: string;
      description?: string;
    } | null;
    note: string | null;
    carrierBookingNumber: string | null;
    memberReference: string | null;
    containers: string[];
    /** @format reported-by-enum */
    reportedBy: ReportedBy;
    canBeInvoiced: boolean;
    /** Shipment report UUIDs this OBL has appeared in */
    reportUuids: string[];
    /** Report UUID and title per linked report; populated on invoice/credit create-list only. */
    reports?: {
      /** @format uuid */
      reportUuid: string;
      /** Report title from shipmentReports; empty when the report row is missing. */
      title: string;
    }[];
    financeStatus: {
      /** Net TEU currently considered invoiced (invoiced - credited) */
      teuInvoiced: number;
      amountInvoiced: number;
      amountPaid?: number | null;
      teuVidBatched?: number | null;
      amountVidBatched?: number | null;
      teuTopUpVidBatched?: number | null;
      amountTopUpVidBatched?: number | null;
      /** List of invoices applied to this OBL */
      invoices?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      /** List of credits applied to this OBL */
      credits?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      vidBatches?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      topUpVidBatches?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
    };
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  };
  /** The amount of TEU that can be credited based on the identified invoice. */
  creditableTeu: number;
  /**
   * The UID of the invoice identified for the credit TEU price basis.
   * @format uuid
   */
  creditableInvoiceUid: string;
}

/** Structure for an item within a credit creation payload. */
export interface CreditItemDTO {
  /** The OBL identifier of the shipment to credit. */
  obl: string;
  /**
   * The specific TEU amount to credit for this OBL.
   * @format float
   * @min 1
   */
  teu: number;
  /**
   * The UID of the invoice to use as the price basis for this credit item.
   * @format uuid
   */
  invoiceUid: string;
}

export interface ActiveShipmentsQueryFilter {
  obl?: string[] | null;
  originUnlocode?: string[] | null;
  destinationUnlocode?: string[] | null;
  contractCode?: string[] | null;
  memberReference?: string[] | null;
  carrierBookingNumber?: string[] | null;
  /** UIDs of the carrier companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
  carrierCompanyId?: string[] | null;
  /** UIDs of the member companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
  memberCompanyId?: string[] | null;
  shippedAt?:
    | {
        /** @format date-time-filter */
        from?: Date | "@" | "!@";
        /** @format date-time-filter */
        to?: Date | "@" | "!@";
      }[]
    | null;
  reportedBy?: ReportedBy[] | null;
  canBeInvoiced?: boolean | null;
  hasUninvoicedTeu?: boolean | null;
  /** Filter for shipments where invoiced TEU > shipped TEU (potential correction needed) */
  canBeCorrected?: boolean | null;
  /** Filter for shipments where invoiced TEU > 0 */
  hasBeenInvoiced?: boolean | null;
  /** Filter by invoice UIDs present in the financeStatus.invoices array */
  invoiceUid?: string[] | null;
  /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
  canBeVidBatched?: boolean | null;
  /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
  canBeTopUpVidBatched?: boolean | null;
  /** Filter for shipments that have staged VID corrections */
  hasVidCorrections?: boolean | null;
  /** Filter by shipment report UUID from a member/carrier import. Prefix with '!' to exclude. Use '@' for any value and '!@' for none. */
  reportUuid?: string[] | null;
  /** Filter for shipments from (non-)OSSI member companies */
  isOSSIMember?: boolean | null;
}

export interface InvoiceShipmentsQueryFilter {
  obl?: string[] | null;
  originUnlocode?: string[] | null;
  destinationUnlocode?: string[] | null;
}

export interface InvoicesQueryFilter {
  /** Filter by invoice title or uid (partial match) */
  searchTerm?: string[];
  /** Filter by invoice titles (partial match) */
  title?: string[] | null;
  /** Filter by carrier UIDs */
  carrierUid?: string[] | null;
  /** Filter by invoice UIDs */
  invoiceUid?: string[] | null;
  createdAt?: {
    /**
     * Filter invoices created after this date
     * @format date-time-filter
     */
    from?: Date | "@" | "!@";
    /**
     * Filter invoices created before this date
     * @format date-time-filter
     */
    to?: Date | "@" | "!@";
  } | null;
}

export interface FinanceRecord {
  /** @format uuid */
  uid: string;
  teu: number;
  amount: number;
  companyUid: string;
  /** @format date-time */
  createdAt: Date;
  isCorrection?: boolean;
  /** @format date-time */
  paidAt?: Date;
}

export interface FinanceStatus {
  /** Net TEU currently considered invoiced (invoiced - credited) */
  teuInvoiced: number;
  amountInvoiced: number;
  amountPaid?: number | null;
  teuVidBatched?: number | null;
  amountVidBatched?: number | null;
  teuTopUpVidBatched?: number | null;
  amountTopUpVidBatched?: number | null;
  /** List of invoices applied to this OBL */
  invoices?:
    | {
        /** @format uuid */
        uid: string;
        teu: number;
        amount: number;
        companyUid: string;
        /** @format date-time */
        createdAt: Date;
        isCorrection?: boolean;
        /** @format date-time */
        paidAt?: Date;
      }[]
    | null;
  /** List of credits applied to this OBL */
  credits?:
    | {
        /** @format uuid */
        uid: string;
        teu: number;
        amount: number;
        companyUid: string;
        /** @format date-time */
        createdAt: Date;
        isCorrection?: boolean;
        /** @format date-time */
        paidAt?: Date;
      }[]
    | null;
  vidBatches?:
    | {
        /** @format uuid */
        uid: string;
        teu: number;
        amount: number;
        companyUid: string;
        /** @format date-time */
        createdAt: Date;
        isCorrection?: boolean;
        /** @format date-time */
        paidAt?: Date;
      }[]
    | null;
  topUpVidBatches?:
    | {
        /** @format uuid */
        uid: string;
        teu: number;
        amount: number;
        companyUid: string;
        /** @format date-time */
        createdAt: Date;
        isCorrection?: boolean;
        /** @format date-time */
        paidAt?: Date;
      }[]
    | null;
}

export interface InvoiceDTO {
  /** Unique identifier for the invoice */
  uid: string;
  /** Title of the invoice */
  title: string;
  /** Description of the invoice */
  description: string;
  /** The carrier company associated with this invoice */
  carrier: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  /**
   * Date and time when the invoice was created
   * @format date-time
   */
  createdAt: Date;
  /** Number of shipments included in this invoice */
  shipmentCount: number;
  /** Total number of TEUs in this invoice */
  teuCount: number;
  /** Total amount of the invoice */
  sumTotal: number;
}

export interface InvoiceRowDTO {
  invoiceRowUuid?: string;
  invoiceUid?: string;
  obl?: string;
  teuInvoiced?: number;
  /** @format date-time */
  paidAt?: Date;
  /** @format date-time */
  createdAt?: Date;
  shipment?: {
    /** @format uuid */
    activeShipmentUuid: string;
    obl: string;
    teu: number;
    /** @format date-time */
    shippedAt: Date;
    memberCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    carrierCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    originUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    destinationUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    contractCode: {
      contractCode: string;
      description?: string;
    } | null;
    note: string | null;
    carrierBookingNumber: string | null;
    memberReference: string | null;
    containers: string[];
    /** @format reported-by-enum */
    reportedBy: ReportedBy;
    canBeInvoiced: boolean;
    /** Shipment report UUIDs this OBL has appeared in */
    reportUuids: string[];
    /** Report UUID and title per linked report; populated on invoice/credit create-list only. */
    reports?: {
      /** @format uuid */
      reportUuid: string;
      /** Report title from shipmentReports; empty when the report row is missing. */
      title: string;
    }[];
    financeStatus: {
      /** Net TEU currently considered invoiced (invoiced - credited) */
      teuInvoiced: number;
      amountInvoiced: number;
      amountPaid?: number | null;
      teuVidBatched?: number | null;
      amountVidBatched?: number | null;
      teuTopUpVidBatched?: number | null;
      amountTopUpVidBatched?: number | null;
      /** List of invoices applied to this OBL */
      invoices?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      /** List of credits applied to this OBL */
      credits?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      vidBatches?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      topUpVidBatches?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
    };
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  };
}

export interface CreditDTO {
  /** Unique identifier for the credit */
  uid: string;
  /** Title of the credit */
  title: string;
  /** Description of the credit */
  description: string;
  /** The carrier company associated with this credit */
  carrier: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  /**
   * Date and time when the credit was created
   * @format date-time
   */
  createdAt: Date;
  /** Number of shipments included in this credit */
  shipmentCount: number;
  /** Total number of TEUs credited */
  teuCount: number;
  /** Total amount of the credit */
  sumTotal: number;
}

export interface CreditRowDTO {
  /** @format uuid */
  creditRowUuid?: string;
  obl?: string;
  teuCredited?: number;
  isCorrection?: boolean;
  /** @format date-time */
  createdAt?: Date;
  /** Price per TEU applied for this credit row */
  price?: number;
  /** Total credited amount for this row (teuCredited * price) */
  amount?: number;
  shipment?: {
    /** @format uuid */
    activeShipmentUuid: string;
    obl: string;
    teu: number;
    /** @format date-time */
    shippedAt: Date;
    memberCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    carrierCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    originUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    destinationUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    contractCode: {
      contractCode: string;
      description?: string;
    } | null;
    note: string | null;
    carrierBookingNumber: string | null;
    memberReference: string | null;
    containers: string[];
    /** @format reported-by-enum */
    reportedBy: ReportedBy;
    canBeInvoiced: boolean;
    /** Shipment report UUIDs this OBL has appeared in */
    reportUuids: string[];
    /** Report UUID and title per linked report; populated on invoice/credit create-list only. */
    reports?: {
      /** @format uuid */
      reportUuid: string;
      /** Report title from shipmentReports; empty when the report row is missing. */
      title: string;
    }[];
    financeStatus: {
      /** Net TEU currently considered invoiced (invoiced - credited) */
      teuInvoiced: number;
      amountInvoiced: number;
      amountPaid?: number | null;
      teuVidBatched?: number | null;
      amountVidBatched?: number | null;
      teuTopUpVidBatched?: number | null;
      amountTopUpVidBatched?: number | null;
      /** List of invoices applied to this OBL */
      invoices?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      /** List of credits applied to this OBL */
      credits?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      vidBatches?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      topUpVidBatches?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
    };
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  };
}

export interface ReportsQueryFilter {
  /** Filter by report titles (partial match) */
  title?: string[] | null;
  /** Filter by report UUIDs */
  reportUuid?: string[] | null;
  /** Filter by company UIDs */
  companyUid?: string[] | null;
  /** Filter by report type (member or carrier) */
  type?: ReportType[] | null;
  createdAt?: {
    /**
     * Filter reports created after this date
     * @format date-time-filter
     */
    from?: Date | "@" | "!@";
    /**
     * Filter reports created before this date
     * @format date-time-filter
     */
    to?: Date | "@" | "!@";
  } | null;
}

export interface CreditsQueryFilter {
  /** Filter by credit titles (partial match) */
  title?: string[] | null;
  /** Filter by carrier UIDs */
  carrierUid?: string[] | null;
  /** Filter by credit UIDs */
  creditUid?: string[] | null;
  createdAt?: {
    /**
     * Filter credits created after this date
     * @format date-time-filter
     */
    from?: Date | "@" | "!@";
    /**
     * Filter credits created before this date
     * @format date-time-filter
     */
    to?: Date | "@" | "!@";
  } | null;
}

export interface CreditShipmentsQueryFilter {
  obl?: string[] | null;
  originUnlocode?: string[] | null;
  destinationUnlocode?: string[] | null;
  /** Filter by whether the credit row is a correction */
  isCorrection?: boolean | null;
}

export interface VidBatchDTO {
  /**
   * Unique identifier for the VID batch
   * @format uuid
   */
  uid: string;
  /** Title of the VID batch */
  title: string;
  /** Description of the VID batch */
  description: string;
  /** Number of shipments included in this batch */
  shipmentCount: number;
  /**
   * Total number of TEUs in this batch
   * @format float
   */
  teuCount: number;
  /**
   * Total amount of the batch (calculated from teuCount * teuPrice)
   * @format float
   */
  sumTotal: number;
  /**
   * Price per TEU used for this batch
   * @format float
   */
  teuPrice: number;
  /** @format vid-type-enum */
  type: VIDType;
  /** @format date-time */
  periodStartAt?: Date | null;
  /** @format date-time */
  periodEndAt?: Date | null;
  /**
   * Date and time when the batch was created
   * @format date-time
   */
  createdAt: Date;
  /** Optional array of member summaries included in this batch (only present when fetching single batch) */
  memberBatches?:
    | {
        member: {
          uid: string;
          name: string;
          /** @format date-time */
          deactivatedAt?: Date;
          /** @format date-time */
          archivedAt?: Date;
        };
        /** Total TEU batched for this member in this batch. */
        totalTeu: number;
        /** Total amount calculated for this member in this batch. */
        totalAmount: number;
        /** Total number of shipments included for this member in this batch. */
        shipmentCount: number;
      }[]
    | null;
}

export interface VidBatchRowDTO {
  /** @format uuid */
  vidBatchRowUuid: string;
  /** @format uuid */
  vidBatchUid: string;
  obl: string;
  /**
   * TEU included in the batch for this specific OBL
   * @format float
   */
  teu: number;
  /**
   * The date when the shipment was shipped
   * @format date-time
   */
  shippedAt?: Date | null;
  /**
   * Amount calculated for this row (teu * batch.teuPrice)
   * @format float
   */
  amount: number;
  /** @format date-time */
  createdAt: Date;
  /** @format date-time */
  updatedAt: Date;
}

export interface VidBatchesQueryFilter {
  /** Filter by batch titles (partial match) */
  title?: string[] | null;
  /** Filter by VID batch UIDs */
  vidBatchUid?: string[] | null;
  /** Filter by VID batch type */
  type?: VIDType[] | null;
  createdAt?: {
    /**
     * Filter batches created after this date
     * @format date-time-filter
     */
    from?: Date | "@" | "!@";
    /**
     * Filter batches created before this date
     * @format date-time-filter
     */
    to?: Date | "@" | "!@";
  } | null;
}

export interface VidBatchShipmentsQueryFilter {
  obl?: string[] | null;
}

/** Represents an Active Shipment eligible for VID batching. */
export interface VidBatchableShipmentDTO {
  /** The OBL of the shipment. */
  obl: string;
  /** The full ActiveShipment details. */
  shipment: {
    /** @format uuid */
    activeShipmentUuid: string;
    obl: string;
    teu: number;
    /** @format date-time */
    shippedAt: Date;
    memberCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    carrierCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    originUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    destinationUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    contractCode: {
      contractCode: string;
      description?: string;
    } | null;
    note: string | null;
    carrierBookingNumber: string | null;
    memberReference: string | null;
    containers: string[];
    /** @format reported-by-enum */
    reportedBy: ReportedBy;
    canBeInvoiced: boolean;
    /** Shipment report UUIDs this OBL has appeared in */
    reportUuids: string[];
    /** Report UUID and title per linked report; populated on invoice/credit create-list only. */
    reports?: {
      /** @format uuid */
      reportUuid: string;
      /** Report title from shipmentReports; empty when the report row is missing. */
      title: string;
    }[];
    financeStatus: {
      /** Net TEU currently considered invoiced (invoiced - credited) */
      teuInvoiced: number;
      amountInvoiced: number;
      amountPaid?: number | null;
      teuVidBatched?: number | null;
      amountVidBatched?: number | null;
      teuTopUpVidBatched?: number | null;
      amountTopUpVidBatched?: number | null;
      /** List of invoices applied to this OBL */
      invoices?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      /** List of credits applied to this OBL */
      credits?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      vidBatches?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      topUpVidBatches?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
    };
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  };
  /** The amount of TEU currently available for batching (net invoiced/credited - net batched). */
  batchableTeu: number;
}

/** Represents a VID batch correction item. */
export type VidBatchableCorrectionDTO = {
  /** The OBL of the shipment. */
  obl: string;
  /** The full ActiveShipment details. */
  shipment: {
    /** @format uuid */
    activeShipmentUuid: string;
    obl: string;
    teu: number;
    /** @format date-time */
    shippedAt: Date;
    memberCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    carrierCompany: {
      uid: string;
      name: string;
      /** @format date-time */
      deactivatedAt?: Date;
      /** @format date-time */
      archivedAt?: Date;
    } | null;
    originUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    destinationUnlocode: {
      unlocode: string;
      countryCode: string;
      placeCode: string;
      name: string;
      plainName: string;
      coordinates?: {
        long?: number;
        lat?: number;
      };
      subDivision: string;
      status: string;
      sourceUpdated: string;
      IATA: string;
      /** @format date-time */
      createdAt: Date;
      /** @format date-time */
      updatedAt: Date;
    } | null;
    contractCode: {
      contractCode: string;
      description?: string;
    } | null;
    note: string | null;
    carrierBookingNumber: string | null;
    memberReference: string | null;
    containers: string[];
    /** @format reported-by-enum */
    reportedBy: ReportedBy;
    canBeInvoiced: boolean;
    /** Shipment report UUIDs this OBL has appeared in */
    reportUuids: string[];
    /** Report UUID and title per linked report; populated on invoice/credit create-list only. */
    reports?: {
      /** @format uuid */
      reportUuid: string;
      /** Report title from shipmentReports; empty when the report row is missing. */
      title: string;
    }[];
    financeStatus: {
      /** Net TEU currently considered invoiced (invoiced - credited) */
      teuInvoiced: number;
      amountInvoiced: number;
      amountPaid?: number | null;
      teuVidBatched?: number | null;
      amountVidBatched?: number | null;
      teuTopUpVidBatched?: number | null;
      amountTopUpVidBatched?: number | null;
      /** List of invoices applied to this OBL */
      invoices?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      /** List of credits applied to this OBL */
      credits?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      vidBatches?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
      topUpVidBatches?:
        | {
            /** @format uuid */
            uid: string;
            teu: number;
            amount: number;
            companyUid: string;
            /** @format date-time */
            createdAt: Date;
            isCorrection?: boolean;
            /** @format date-time */
            paidAt?: Date;
          }[]
        | null;
    };
    /** @format date-time */
    createdAt: Date;
    /** @format date-time */
    updatedAt: Date;
  };
  /** The amount of TEU currently available for batching (net invoiced/credited - net batched). */
  batchableTeu: number;
} & {
  /** The UID of the VID batch correction item. */
  uid: string;
  /** The correction amount. */
  amount: number;
};

/** An item within a VID batch creation payload. */
export interface VidBatchItemDTO {
  /** The OBL identifier of the shipment to include. */
  obl: string;
  /**
   * The specific TEU amount to batch for this OBL. Positive value converted to negative when it becomes a credit row.
   * @format float
   * @min 0.01
   */
  teu: number;
}

/** A correction within a VID batch payload, includes correction UID and allows both credit (negative teu) and debit (positive teu). */
export interface VidBatchCorrectionDTO {
  /** The OBL identifier of the shipment to include. */
  obl: string;
  /**
   * The specific TEU amount to batch for this OBL. Negative for credits, positive for debits.
   * @format float
   */
  teu: number;
  /** The unique identifier of the correction item. */
  uid: string;
}

/** Summary of VID batch details aggregated per member company. */
export interface MemberBatchDTO {
  member: {
    uid: string;
    name: string;
    /** @format date-time */
    deactivatedAt?: Date;
    /** @format date-time */
    archivedAt?: Date;
  };
  /** Total TEU batched for this member in this batch. */
  totalTeu: number;
  /** Total amount calculated for this member in this batch. */
  totalAmount: number;
  /** Total number of shipments included for this member in this batch. */
  shipmentCount: number;
}

export interface VidBatchMemberRowsQueryFilter {
  /** Filter rows by OBL ID(s). */
  obl?: string[] | null;
}

export interface ReverseSearchAliasesListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    aliasType?: AliasType[] | null;
    alias?: string[] | null;
    entityPublicId?: string[] | null;
  };
  searchTerm: string;
}

export interface AliasesListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: AliasesListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    aliasType?: AliasType[] | null;
    alias?: string[] | null;
    entityPublicId?: string[] | null;
  };
}

export enum AliasesListParamsSortby {
  Alias = "alias",
  KnownValue = "knownValue",
}

export interface AliasesCreatePayload {
  alias: string;
  /** @format alias-type-enum */
  aliasType: AliasType;
  /** The public id for the entity this alias maps to */
  entityPublicId: string;
}

export interface AliasesUpdatePayload {
  alias: string;
  /** @format alias-type-enum */
  aliasType: AliasType;
  /** The public id for the entity this alias maps to */
  entityPublicId: string;
}

export interface AmendmentsUpdatePayload {
  /** Amendment title, required when updating draft */
  title?: string;
  /** @format date-time */
  activeAt?: Date;
  /** @format date-time */
  expiredAt?: Date;
  note?: string;
  /** Contract code, only allowed as admin when updating accepted amendment */
  contractCode?: string | null;
}

export interface ImportUpdatePayload {
  file?: File;
}

export interface LegChangesListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: LegChangesListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    templateLegId?: string[] | null;
    originUnlocodeGroup?: string[] | null;
    destinationUnlocodeGroup?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    originCountry?: string[] | null;
    originPlace?: string[] | null;
    destinationCountry?: string[] | null;
    destinationPlace?: string[] | null;
    equipmentType?: EquipmentType[] | null;
    modality?: Modality[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  } & {
    status?: ContractLegStatus[] | null;
    changeType?: AmendmentChangeType[] | null;
    service?: string[] | null;
    tradeLane?:
      | {
          origin?: string;
          destination?: string;
        }[]
      | null;
    groupUuid?: string[] | null;
    legUuid?: string[] | null;
    contractId?: string[] | null;
    costBaseRate?: {
      from?: number | null;
      to?: number | null;
    }[];
    costBaseRateCurrency?: string[] | null;
    timeTransit?: {
      from?: number | null;
      to?: number | null;
    }[];
    activeAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    expiredAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    /** @format contract-leg-grouping-enum */
    legGrouping?: ContractLegQueryFilterLegGrouping;
  };
  /** the path parameter for the amendment UID */
  amendmentUid: string;
}

export enum LegChangesListParamsSortby {
  TemplateLegId = "templateLegId",
  OriginCountry = "originCountry",
  OriginPlace = "originPlace",
  DestinationCountry = "destinationCountry",
  DestinationPlace = "destinationPlace",
  EquipmentType = "equipmentType",
  Modality = "modality",
}

export interface LegChangesLocationsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** order locations by this value (default by name) */
  sortby?: LegChangesLocationsListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). */
  f?: {
    terminus?: TerminusType[] | null;
    locationType?: LocationType[] | null;
    values?: string[] | null;
  };
  /** the path parameter for the amendment UID */
  amendmentUid: string;
}

/** order locations by this value (default by name) */
export enum LegChangesLocationsListParamsSortby {
  Name = "name",
  Type = "type",
  GroupType = "groupType",
  PlainName = "plainName",
  SubDivision = "subDivision",
  CountryCode = "countryCode",
  PlaceCode = "placeCode",
  Unlocode = "unlocode",
  Terminus = "terminus",
}

export interface LoginCreatePayload {
  /** User email */
  email: string;
  /** User password */
  password: string;
}

export interface LoginCreateParams {
  /** if parameter is present, assume user is logging in from web */
  web?: string;
}

export interface TotpLoginCreatePayload {
  /** Short-lived MFA challenge token returned by the login endpoint */
  mfaToken: string;
  /** 6-digit TOTP authentication code */
  code: string;
}

export interface TotpSetupCreatePayload {
  /** Current user password */
  password: string;
}

export interface TotpEnableCreatePayload {
  /** Short-lived TOTP setup challenge token */
  setupToken: string;
  /** 6-digit TOTP authentication code */
  code: string;
}

export interface TotpDisableCreatePayload {
  /** Current user password */
  password: string;
  /** 6-digit TOTP authentication code */
  code: string;
}

export interface RefreshTokenCreatePayload {
  /** Refresh token */
  refreshToken: string;
}

export interface ForgotPasswordCreatePayload {
  /** User-declared e-mail address */
  email: string;
}

export interface ResetPasswordCreatePayload {
  /** Forgot Password token */
  token: string;
  /** New User password */
  password: string;
}

export interface ChangePasswordCreatePayload {
  /** Current user password */
  oldPassword: string;
  /** New user password */
  password: string;
}

export interface CommoditiesListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
}

export interface CommoditiesCreatePayload {
  title: string;
  description: string;
}

export interface CommoditiesUpdatePayload {
  title: string | null;
  description: string | null;
}

export interface CompaniesListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: CompaniesListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    uid?: string[] | null;
    name?: string[] | null;
    companyType?: CompanyType[] | null;
    address?: string[] | null;
    postCode?: string[] | null;
    city?: string[] | null;
    country?: string[] | null;
    website?: string[] | null;
    phone?: string[] | null;
    fax?: string[] | null;
    invoiceAddress?: string[] | null;
    invoicePostCode?: string[] | null;
    invoiceCity?: string[] | null;
    invoiceCountry?: string[] | null;
    isActive?: (string | boolean)[] | null;
    vat?: string[] | null;
    deactivatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    archivedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    carrierDetails?: (boolean | string)[] | null;
    memberDetails?: (boolean | string)[] | null;
    fromPortal?: boolean[] | null;
  };
}

export enum CompaniesListParamsSortby {
  Country = "country",
  Name = "name",
  Address = "address",
  PostCode = "postCode",
  City = "city",
  InvoiceAddress = "invoiceAddress",
  InvoicePostCode = "invoicePostCode",
  InvoiceCity = "invoiceCity",
  InvoiceCountry = "invoiceCountry",
  DeactivatedAt = "deactivatedAt",
  CompanyType = "companyType",
}

export interface CompaniesCreatePayload {
  /** @format company-type-enum */
  companyType: CompanyType;
  name: string;
  address: string | null;
  postCode: string | null;
  city: string | null;
  country: string | null;
  website: string | null;
  phone: string | null;
  fax?: string | null;
  invoiceAddress: string | null;
  invoicePostCode: string | null;
  invoiceCity: string | null;
  invoiceCountry: string | null;
  vat: string | null;
  carrierDetails?: {
    accountDebit: string | null;
    accountCredit: string | null;
    contact: string | null;
    scac: string | null;
    oblLength: number | null;
  };
  memberDetails?: {
    eori: string | null;
    membershipNumber: string | null;
    osaAccountNumber: string | null;
    onmiAccountNumber: string | null;
    osaMember: boolean;
    ossiMember: boolean;
    affiliateOffice: boolean;
  };
}

export interface ExportCompaniesListParams {
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    uid?: string[] | null;
    name?: string[] | null;
    companyType?: CompanyType[] | null;
    address?: string[] | null;
    postCode?: string[] | null;
    city?: string[] | null;
    country?: string[] | null;
    website?: string[] | null;
    phone?: string[] | null;
    fax?: string[] | null;
    invoiceAddress?: string[] | null;
    invoicePostCode?: string[] | null;
    invoiceCity?: string[] | null;
    invoiceCountry?: string[] | null;
    isActive?: (string | boolean)[] | null;
    vat?: string[] | null;
    deactivatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    archivedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    carrierDetails?: (boolean | string)[] | null;
    memberDetails?: (boolean | string)[] | null;
    fromPortal?: boolean[] | null;
  };
  sortby?: ExportCompaniesListParamsSortby;
}

export enum ExportCompaniesListParamsSortby {
  Country = "country",
  Name = "name",
  Address = "address",
  PostCode = "postCode",
  City = "city",
  InvoiceAddress = "invoiceAddress",
  InvoicePostCode = "invoicePostCode",
  InvoiceCity = "invoiceCity",
  InvoiceCountry = "invoiceCountry",
  DeactivatedAt = "deactivatedAt",
  CompanyType = "companyType",
}

export interface CompaniesUpdatePayload {
  /** @format company-type-enum */
  companyType: CompanyType;
  name: string;
  address: string | null;
  postCode: string | null;
  city: string | null;
  country: string | null;
  website: string | null;
  phone: string | null;
  fax?: string | null;
  invoiceAddress: string | null;
  invoicePostCode: string | null;
  invoiceCity: string | null;
  invoiceCountry: string | null;
  vat: string | null;
  carrierDetails?: {
    accountDebit: string | null;
    accountCredit: string | null;
    contact: string | null;
    scac: string | null;
    oblLength: number | null;
  };
  memberDetails?: {
    eori: string | null;
    membershipNumber: string | null;
    osaAccountNumber: string | null;
    onmiAccountNumber: string | null;
    osaMember: boolean;
    ossiMember: boolean;
    affiliateOffice: boolean;
  };
}

export interface DeactivateUpdatePayload {
  /** @format date-time */
  deactivatedAt: Date;
}

export interface ContractsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: ContractsListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    title?: string[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    activeAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    expiredAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    company?: string[] | null;
    acceptedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    status?: ContractStatusType[] | null;
    contractYear?: (number | string)[] | null;
  };
}

export enum ContractsListParamsSortby {
  Title = "title",
  Uid = "uid",
  ParentContractUid = "parentContractUid",
  Company = "company",
  PublishedAt = "publishedAt",
  AcceptedAt = "acceptedAt",
  ActiveAt = "activeAt",
  ExpiredAt = "expiredAt",
  CreatedAt = "createdAt",
  UpdatedAt = "updatedAt",
}

export interface ContractsCreatePayload {
  title: string;
  carrierUid: string;
  /** @format date-time */
  activeAt: Date | null;
  /** @format date-time */
  expiredAt: Date | null;
}

export interface ContractsUpdatePayload {
  title: string;
  carrierUid: string;
  /** @format date-time */
  activeAt: Date | null;
  /** @format date-time */
  expiredAt: Date | null;
  contractCode: string | null;
}

export interface UpdateAcceptedUpdatePayload {
  contractFields?: {
    name: string;
    isActive: boolean;
    isRequired: boolean;
  }[];
  contractCode: string | null;
}

export interface ContractImportUpdatePayload {
  file?: File;
}

export interface SearchContractCodesListParams {
  searchTerm: string;
  /** the path parameter for the contract UID */
  contractUid: string;
}

export interface AmendmentCreatePayload {
  title: string;
  note?: string | null;
  file?: File | null;
}

export interface ExportListParams {
  sortby?: ExportListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    templateLegId?: string[] | null;
    originUnlocodeGroup?: string[] | null;
    destinationUnlocodeGroup?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    originCountry?: string[] | null;
    originPlace?: string[] | null;
    destinationCountry?: string[] | null;
    destinationPlace?: string[] | null;
    equipmentType?: EquipmentType[] | null;
    modality?: Modality[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  } & {
    status?: ContractLegStatus[] | null;
    changeType?: AmendmentChangeType[] | null;
    service?: string[] | null;
    tradeLane?:
      | {
          origin?: string;
          destination?: string;
        }[]
      | null;
    groupUuid?: string[] | null;
    legUuid?: string[] | null;
    contractId?: string[] | null;
    costBaseRate?: {
      from?: number | null;
      to?: number | null;
    }[];
    costBaseRateCurrency?: string[] | null;
    timeTransit?: {
      from?: number | null;
      to?: number | null;
    }[];
    activeAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    expiredAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    /** @format contract-leg-grouping-enum */
    legGrouping?: ContractLegQueryFilterLegGrouping;
  };
  contractUid: string;
}

export enum ExportListParamsSortby {
  TemplateLegId = "templateLegId",
  OriginCountry = "originCountry",
  OriginPlace = "originPlace",
  DestinationCountry = "destinationCountry",
  DestinationPlace = "destinationPlace",
  EquipmentType = "equipmentType",
  Modality = "modality",
}

export interface ContractAndAmendmentLegsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: ContractAndAmendmentLegsListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    templateLegId?: string[] | null;
    originUnlocodeGroup?: string[] | null;
    destinationUnlocodeGroup?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    originCountry?: string[] | null;
    originPlace?: string[] | null;
    destinationCountry?: string[] | null;
    destinationPlace?: string[] | null;
    equipmentType?: EquipmentType[] | null;
    modality?: Modality[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  } & {
    status?: ContractLegStatus[] | null;
    changeType?: AmendmentChangeType[] | null;
    service?: string[] | null;
    tradeLane?:
      | {
          origin?: string;
          destination?: string;
        }[]
      | null;
    groupUuid?: string[] | null;
    legUuid?: string[] | null;
    contractId?: string[] | null;
    costBaseRate?: {
      from?: number | null;
      to?: number | null;
    }[];
    costBaseRateCurrency?: string[] | null;
    timeTransit?: {
      from?: number | null;
      to?: number | null;
    }[];
    activeAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    expiredAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    /** @format contract-leg-grouping-enum */
    legGrouping?: ContractLegQueryFilterLegGrouping;
  };
  contractUid: string;
}

export enum ContractAndAmendmentLegsListParamsSortby {
  TemplateLegId = "templateLegId",
  OriginCountry = "originCountry",
  OriginPlace = "originPlace",
  DestinationCountry = "destinationCountry",
  DestinationPlace = "destinationPlace",
  EquipmentType = "equipmentType",
  Modality = "modality",
}

export interface ContractAndAmendmentLegsLocationsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** order locations by this value (default by name) */
  sortby?: ContractAndAmendmentLegsLocationsListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). */
  f?: {
    terminus?: TerminusType[] | null;
    locationType?: LocationType[] | null;
    values?: string[] | null;
  };
  contractUid: string;
}

/** order locations by this value (default by name) */
export enum ContractAndAmendmentLegsLocationsListParamsSortby {
  Name = "name",
  Type = "type",
  GroupType = "groupType",
  PlainName = "plainName",
  SubDivision = "subDivision",
  CountryCode = "countryCode",
  PlaceCode = "placeCode",
  Unlocode = "unlocode",
  Terminus = "terminus",
}

export interface ContractAndAmendmentLegsFilteredUpdatePayload {
  contractCode?: string | null;
}

export interface ContractAndAmendmentLegsFilteredUpdateParams {
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    templateLegId?: string[] | null;
    originUnlocodeGroup?: string[] | null;
    destinationUnlocodeGroup?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    originCountry?: string[] | null;
    originPlace?: string[] | null;
    destinationCountry?: string[] | null;
    destinationPlace?: string[] | null;
    equipmentType?: EquipmentType[] | null;
    modality?: Modality[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  } & {
    status?: ContractLegStatus[] | null;
    changeType?: AmendmentChangeType[] | null;
    service?: string[] | null;
    tradeLane?:
      | {
          origin?: string;
          destination?: string;
        }[]
      | null;
    groupUuid?: string[] | null;
    legUuid?: string[] | null;
    contractId?: string[] | null;
    costBaseRate?: {
      from?: number | null;
      to?: number | null;
    }[];
    costBaseRateCurrency?: string[] | null;
    timeTransit?: {
      from?: number | null;
      to?: number | null;
    }[];
    activeAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    expiredAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    /** @format contract-leg-grouping-enum */
    legGrouping?: ContractLegQueryFilterLegGrouping;
  };
  contractUid: string;
}

export interface ContractCodesListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    contractCode?: string[] | null;
  };
}

export interface ContractCodesCreatePayload {
  /** @maxLength 100 */
  contractCode: string;
  /** @maxLength 1024 */
  description: string;
  carrierUid: string;
  /** @maxLength 100 */
  commodityTitle: string;
}

export interface SearchAllContractCodesListParams {
  searchTerm: string;
}

export interface ContractCodesUpdatePayload {
  /** @maxLength 100 */
  contractCode: string;
  /** @maxLength 1024 */
  description: string;
  carrierUid: string;
  /** @maxLength 100 */
  commodityTitle: string;
}

export interface TiersUpdatePayload {
  /** @format tier-type-enum */
  tier: TierTypes;
}

export interface TiersCostsListParams {
  /** The group to get the tier costs from */
  fromGroup?: string;
  /** The group to get the tier costs to */
  toGroup?: string;
  /**
   * the path parameter for the tier type
   * @format tier-type-enum
   */
  tierType?: TierTypes;
}

export interface TiersCostsUpdatePayload {
  fromGroup: string | null;
  toGroup: string | null;
  costs?: {
    /** @format portal-cost-type-enum */
    costType?: PortalCostTypes;
    amount?: number;
    currency?: string;
    /** @format equipment-type-enum */
    equipmentType?: EquipmentType;
    /** @format date-time */
    activeAt?: Date | null;
  }[];
}

export interface AllowedCarriersUpdatePayload {
  carriers?: {
    carrierUid: string;
    isAllowed: boolean;
  }[];
}

export interface ExchangeRatesListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** Query to search by */
  query?: string;
  /** order users by this value (default by email) */
  sortby?: ExchangeRatesListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    currencyCode?: string[] | null;
    currencyDescription?: string[] | null;
    exchangeRate?:
      | {
          from?: number;
          to?: number;
        }[]
      | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    sourceUrl?: string[] | null;
  };
}

/** order users by this value (default by email) */
export enum ExchangeRatesListParamsSortby {
  CurrencyCode = "currencyCode",
  CurrencyDescription = "currencyDescription",
  ExchangeRate = "exchangeRate",
  UpdatedAt = "updatedAt",
}

export interface NewsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    searchTerm?: string[] | null;
    publishedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  };
}

export interface NewsCreatePayload {
  title: string;
  introText: string;
  content?: object;
  syncPortal?: boolean;
  publishNow?: boolean;
  accessGroups: UserGroupName[];
}

export interface NewsUpdatePayload {
  slug?: string;
  title?: string;
  introText?: string;
  content?: object;
  syncPortal?: boolean;
  accessGroups?: UserGroupName[];
}

export interface UploadCreatePayload {
  files?: File[];
  /** @format file-types-enum */
  fileType?: FileTypes;
}

export interface PortalsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: PortalsListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    name?: string[] | null;
    adminEmail?: string[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  };
}

export enum PortalsListParamsSortby {
  Name = "name",
  AdminEmail = "adminEmail",
}

export interface PortalsCreatePayload {
  companyUid: string;
  name: string;
  adminEmail: string;
  publicEmail: string;
  headerLogoPublicUrl: string;
  logoPublicUrl: string;
  coverImagePublicUrl: string;
  domain: string;
  address: string;
  disclaimer: string;
  region: string;
}

export interface PortalsUpdatePayload {
  adminEmail: string;
  publicEmail: string;
  headerLogoPublicUrl: string;
  logoPublicUrl: string;
  coverImagePublicUrl: string;
  domain: string;
  address: string;
  disclaimer: string;
  region: string;
}

export interface NotificationsUnsubscribeCreatePayload {
  token: string;
}

export interface PreferencesUpdatePayload {
  /** @format date-format-enum */
  dateFormat: DateFormats;
  /** @format time-format-enum */
  timeFormat: TimeFormats;
  /** @format number-format-enum */
  numberFormat: NumberFormats;
  /**
   * @minLength 3
   * @maxLength 3
   */
  currency: string;
  equipmentTypes: EquipmentType[];
}

export type NotificationsUpdatePayload = {
  notificationType: {
    /** @format notification-type-enum */
    type: NotificationTypes;
  };
  isSubscribed: boolean;
  asDigest: boolean;
}[];

export interface ActiveShipmentsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: ActiveShipmentsListParamsSortby;
  /** Filter active shipments (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    contractCode?: string[] | null;
    memberReference?: string[] | null;
    carrierBookingNumber?: string[] | null;
    /** UIDs of the carrier companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    carrierCompanyId?: string[] | null;
    /** UIDs of the member companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    memberCompanyId?: string[] | null;
    shippedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    reportedBy?: ReportedBy[] | null;
    canBeInvoiced?: boolean | null;
    hasUninvoicedTeu?: boolean | null;
    /** Filter for shipments where invoiced TEU > shipped TEU (potential correction needed) */
    canBeCorrected?: boolean | null;
    /** Filter for shipments where invoiced TEU > 0 */
    hasBeenInvoiced?: boolean | null;
    /** Filter by invoice UIDs present in the financeStatus.invoices array */
    invoiceUid?: string[] | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeVidBatched?: boolean | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeTopUpVidBatched?: boolean | null;
    /** Filter for shipments that have staged VID corrections */
    hasVidCorrections?: boolean | null;
    /** Filter by shipment report UUID from a member/carrier import. Prefix with '!' to exclude. Use '@' for any value and '!@' for none. */
    reportUuid?: string[] | null;
    /** Filter for shipments from (non-)OSSI member companies */
    isOSSIMember?: boolean | null;
  };
}

export enum ActiveShipmentsListParamsSortby {
  Obl = "obl",
  ShippedAt = "shippedAt",
  Teu = "teu",
  CarrierName = "carrierName",
  MemberName = "memberName",
  OriginLocation = "originLocation",
  DestinationLocation = "destinationLocation",
  CreatedAt = "createdAt",
}

export interface ActiveShipmentsExportListParams {
  /** Filter active shipments (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    contractCode?: string[] | null;
    memberReference?: string[] | null;
    carrierBookingNumber?: string[] | null;
    /** UIDs of the carrier companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    carrierCompanyId?: string[] | null;
    /** UIDs of the member companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    memberCompanyId?: string[] | null;
    shippedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    reportedBy?: ReportedBy[] | null;
    canBeInvoiced?: boolean | null;
    hasUninvoicedTeu?: boolean | null;
    /** Filter for shipments where invoiced TEU > shipped TEU (potential correction needed) */
    canBeCorrected?: boolean | null;
    /** Filter for shipments where invoiced TEU > 0 */
    hasBeenInvoiced?: boolean | null;
    /** Filter by invoice UIDs present in the financeStatus.invoices array */
    invoiceUid?: string[] | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeVidBatched?: boolean | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeTopUpVidBatched?: boolean | null;
    /** Filter for shipments that have staged VID corrections */
    hasVidCorrections?: boolean | null;
    /** Filter by shipment report UUID from a member/carrier import. Prefix with '!' to exclude. Use '@' for any value and '!@' for none. */
    reportUuid?: string[] | null;
    /** Filter for shipments from (non-)OSSI member companies */
    isOSSIMember?: boolean | null;
  };
}

export interface ActiveShipmentsUpdatePayload {
  /** @format date-time */
  shippedAt: Date;
  memberUid: string;
  carrierUid: string;
  originUnlocode: string;
  destinationUnlocode: string;
  teu: number;
  contractCode: string;
  note?: string | null;
  carrierBookingNumber?: string | null;
  memberReference?: string | null;
  containers?: string[];
  canBeInvoiced?: boolean;
  /** @format reported-by-enum */
  reportedBy: ReportedBy;
}

export interface CreditsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: CreditsListParamsSortby;
  /** Filter credits (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    /** Filter by credit titles (partial match) */
    title?: string[] | null;
    /** Filter by carrier UIDs */
    carrierUid?: string[] | null;
    /** Filter by credit UIDs */
    creditUid?: string[] | null;
    createdAt?: {
      /**
       * Filter credits created after this date
       * @format date-time-filter
       */
      from?: Date | "@" | "!@";
      /**
       * Filter credits created before this date
       * @format date-time-filter
       */
      to?: Date | "@" | "!@";
    } | null;
  };
}

export enum CreditsListParamsSortby {
  CreditUid = "creditUid",
  Title = "title",
  CarrierName = "carrierName",
  CreatedAt = "createdAt",
  ShipmentCount = "shipmentCount",
  TeuCount = "teuCount",
  SumTotal = "sumTotal",
}

export interface CreditsCreatePayload {
  /** The title for the new credit */
  title: string;
  /** The description for the new credit */
  description: string;
  /**
   * The UID of the carrier company this credit belongs to
   * @format uuid
   */
  carrierUid: string;
  /** List of standard shipment items to be included in the credit. */
  items:
    | {
        /** The OBL identifier of the shipment to credit. */
        obl: string;
        /**
         * The specific TEU amount to credit for this OBL.
         * @format float
         * @min 1
         */
        teu: number;
        /**
         * The UID of the invoice to use as the price basis for this credit item.
         * @format uuid
         */
        invoiceUid: string;
      }[]
    | null;
  /** List of correction items to be included in the credit. */
  corrections?:
    | {
        /** The OBL identifier of the shipment to credit. */
        obl: string;
        /**
         * The specific TEU amount to credit for this OBL.
         * @format float
         * @min 1
         */
        teu: number;
        /**
         * The UID of the invoice to use as the price basis for this credit item.
         * @format uuid
         */
        invoiceUid: string;
      }[]
    | null;
}

export interface CreditsCreateListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: CreditsCreateListParamsSortby;
  /** Filter active shipments (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    contractCode?: string[] | null;
    memberReference?: string[] | null;
    carrierBookingNumber?: string[] | null;
    /** UIDs of the carrier companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    carrierCompanyId?: string[] | null;
    /** UIDs of the member companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    memberCompanyId?: string[] | null;
    shippedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    reportedBy?: ReportedBy[] | null;
    canBeInvoiced?: boolean | null;
    hasUninvoicedTeu?: boolean | null;
    /** Filter for shipments where invoiced TEU > shipped TEU (potential correction needed) */
    canBeCorrected?: boolean | null;
    /** Filter for shipments where invoiced TEU > 0 */
    hasBeenInvoiced?: boolean | null;
    /** Filter by invoice UIDs present in the financeStatus.invoices array */
    invoiceUid?: string[] | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeVidBatched?: boolean | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeTopUpVidBatched?: boolean | null;
    /** Filter for shipments that have staged VID corrections */
    hasVidCorrections?: boolean | null;
    /** Filter by shipment report UUID from a member/carrier import. Prefix with '!' to exclude. Use '@' for any value and '!@' for none. */
    reportUuid?: string[] | null;
    /** Filter for shipments from (non-)OSSI member companies */
    isOSSIMember?: boolean | null;
  };
}

export enum CreditsCreateListParamsSortby {
  Obl = "obl",
  ShippedAt = "shippedAt",
  Teu = "teu",
  CarrierName = "carrierName",
  MemberName = "memberName",
  OriginLocation = "originLocation",
  DestinationLocation = "destinationLocation",
  CreatedAt = "createdAt",
}

export interface CreditsCorrectionsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: CreditsCorrectionsListParamsSortby;
  /** Filter active shipments (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    contractCode?: string[] | null;
    memberReference?: string[] | null;
    carrierBookingNumber?: string[] | null;
    /** UIDs of the carrier companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    carrierCompanyId?: string[] | null;
    /** UIDs of the member companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    memberCompanyId?: string[] | null;
    shippedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    reportedBy?: ReportedBy[] | null;
    canBeInvoiced?: boolean | null;
    hasUninvoicedTeu?: boolean | null;
    /** Filter for shipments where invoiced TEU > shipped TEU (potential correction needed) */
    canBeCorrected?: boolean | null;
    /** Filter for shipments where invoiced TEU > 0 */
    hasBeenInvoiced?: boolean | null;
    /** Filter by invoice UIDs present in the financeStatus.invoices array */
    invoiceUid?: string[] | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeVidBatched?: boolean | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeTopUpVidBatched?: boolean | null;
    /** Filter for shipments that have staged VID corrections */
    hasVidCorrections?: boolean | null;
    /** Filter by shipment report UUID from a member/carrier import. Prefix with '!' to exclude. Use '@' for any value and '!@' for none. */
    reportUuid?: string[] | null;
    /** Filter for shipments from (non-)OSSI member companies */
    isOSSIMember?: boolean | null;
  };
}

export enum CreditsCorrectionsListParamsSortby {
  Obl = "obl",
  ShippedAt = "shippedAt",
  Teu = "teu",
  CarrierName = "carrierName",
  MemberName = "memberName",
  OriginLocation = "originLocation",
  DestinationLocation = "destinationLocation",
  CreatedAt = "createdAt",
}

export interface CreditsUpdatePayload {
  title: string;
  description: string;
}

export interface CreditsShipmentsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** Filter credit shipment rows (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    /** Filter by whether the credit row is a correction */
    isCorrection?: boolean | null;
  };
  /** the path parameter for the credit UID */
  creditUid?: string;
}

export interface CreditsExportListParams {
  /** Filter credit shipment rows (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    /** Filter by whether the credit row is a correction */
    isCorrection?: boolean | null;
  };
  /** the path parameter for the credit UID */
  creditUid?: string;
}

export interface ImportShipmentsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: ImportShipmentsListParamsSortby;
  /** Filter import shipments (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    contractCode?: string[] | null;
    memberReference?: string[] | null;
    carrierBookingNumber?: string[] | null;
    carrierUid?: string[] | null;
    reportTitle?: string[] | null;
    shippedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    memberUid?: string[] | null;
    status?: ShipmentStatus[] | null;
    /** Import UUIDs to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    importUuid?: string[] | null;
  };
}

export enum ImportShipmentsListParamsSortby {
  Obl = "obl",
  ShippedAt = "shippedAt",
  Carrier = "carrier",
  Member = "member",
  Origin = "origin",
  Destination = "destination",
  Teu = "teu",
  CarrierBookingNumber = "carrierBookingNumber",
  ReportTitle = "reportTitle",
  ContractCode = "contractCode",
}

export interface ImportShipmentsCreatePayload {
  obl: string;
  teu: number;
  /** @format date-time */
  shippedAt: Date;
  memberCompanyUid: string;
  carrierCompanyUid: string;
  originUnlocode: string;
  destinationUnlocode: string;
  contractCode: string;
  note: string | null;
  carrierBookingNumber: string | null;
  memberReference: string | null;
  containers: string[];
  /** @format reported-by-enum */
  reportedBy: ReportedBy;
}

export interface ImportShipmentsExportListParams {
  /** Filter import shipments (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    contractCode?: string[] | null;
    memberReference?: string[] | null;
    carrierBookingNumber?: string[] | null;
    carrierUid?: string[] | null;
    reportTitle?: string[] | null;
    shippedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    memberUid?: string[] | null;
    status?: ShipmentStatus[] | null;
    /** Import UUIDs to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    importUuid?: string[] | null;
  };
}

export interface ImportShipmentsUpdatePayload {
  obl: string;
  teu: number;
  /** @format date-time */
  shippedAt: Date;
  memberCompanyUid: string;
  carrierCompanyUid: string;
  originUnlocode: string;
  destinationUnlocode: string;
  contractCode: string;
  note: string | null;
  carrierBookingNumber: string | null;
  memberReference: string | null;
  containers: string[];
  /** @format reported-by-enum */
  reportedBy: ReportedBy;
}

export type ImportShipmentsResolveDuplicateUpdatePayload = {
  obl: string;
  teu: number;
  /** @format date-time */
  shippedAt: Date;
  memberCompanyUid: string;
  carrierCompanyUid: string;
  originUnlocode: string;
  destinationUnlocode: string;
  contractCode: string;
  note: string | null;
  carrierBookingNumber: string | null;
  memberReference: string | null;
  containers: string[];
  /** @format reported-by-enum */
  reportedBy: ReportedBy;
} & {
  importUuid: string;
  /** @format shipment-duplicate-resolution-enum */
  resolveMethod: ShipmentDuplicateResolution;
  correctImportUuid?: string | null;
  incorrectImportUuids?: string[] | null;
};

export interface ImportShipmentsReportCreatePayload {
  title: string;
  companyUid: string;
  file?: File;
}

export interface ImportShipmentsMultiDeletePayload {
  importUuids: string[];
}

export interface ImportShipmentsProcessCreatePayload {
  importUuids: string[];
}

export interface InvoicesListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: InvoicesListParamsSortby;
  /** Filter invoices (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    /** Filter by invoice title or uid (partial match) */
    searchTerm?: string[];
    /** Filter by invoice titles (partial match) */
    title?: string[] | null;
    /** Filter by carrier UIDs */
    carrierUid?: string[] | null;
    /** Filter by invoice UIDs */
    invoiceUid?: string[] | null;
    createdAt?: {
      /**
       * Filter invoices created after this date
       * @format date-time-filter
       */
      from?: Date | "@" | "!@";
      /**
       * Filter invoices created before this date
       * @format date-time-filter
       */
      to?: Date | "@" | "!@";
    } | null;
  };
}

export enum InvoicesListParamsSortby {
  InvoiceUid = "invoiceUid",
  Title = "title",
  CarrierName = "carrierName",
  CreatedAt = "createdAt",
  ShipmentCount = "shipmentCount",
  TeuCount = "teuCount",
  SumTotal = "sumTotal",
}

export interface InvoicesCreatePayload {
  title: string;
  description: string;
  carrierUid: string;
  teuPrice: number;
  oblIds: string[];
}

export interface InvoicesCreateExportListParams {
  /** Filter active shipments (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    contractCode?: string[] | null;
    memberReference?: string[] | null;
    carrierBookingNumber?: string[] | null;
    /** UIDs of the carrier companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    carrierCompanyId?: string[] | null;
    /** UIDs of the member companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    memberCompanyId?: string[] | null;
    shippedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    reportedBy?: ReportedBy[] | null;
    canBeInvoiced?: boolean | null;
    hasUninvoicedTeu?: boolean | null;
    /** Filter for shipments where invoiced TEU > shipped TEU (potential correction needed) */
    canBeCorrected?: boolean | null;
    /** Filter for shipments where invoiced TEU > 0 */
    hasBeenInvoiced?: boolean | null;
    /** Filter by invoice UIDs present in the financeStatus.invoices array */
    invoiceUid?: string[] | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeVidBatched?: boolean | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeTopUpVidBatched?: boolean | null;
    /** Filter for shipments that have staged VID corrections */
    hasVidCorrections?: boolean | null;
    /** Filter by shipment report UUID from a member/carrier import. Prefix with '!' to exclude. Use '@' for any value and '!@' for none. */
    reportUuid?: string[] | null;
    /** Filter for shipments from (non-)OSSI member companies */
    isOSSIMember?: boolean | null;
  };
}

export interface InvoicesCreateListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: InvoicesCreateListParamsSortby;
  /** Filter active shipments (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    contractCode?: string[] | null;
    memberReference?: string[] | null;
    carrierBookingNumber?: string[] | null;
    /** UIDs of the carrier companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    carrierCompanyId?: string[] | null;
    /** UIDs of the member companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    memberCompanyId?: string[] | null;
    shippedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    reportedBy?: ReportedBy[] | null;
    canBeInvoiced?: boolean | null;
    hasUninvoicedTeu?: boolean | null;
    /** Filter for shipments where invoiced TEU > shipped TEU (potential correction needed) */
    canBeCorrected?: boolean | null;
    /** Filter for shipments where invoiced TEU > 0 */
    hasBeenInvoiced?: boolean | null;
    /** Filter by invoice UIDs present in the financeStatus.invoices array */
    invoiceUid?: string[] | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeVidBatched?: boolean | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeTopUpVidBatched?: boolean | null;
    /** Filter for shipments that have staged VID corrections */
    hasVidCorrections?: boolean | null;
    /** Filter by shipment report UUID from a member/carrier import. Prefix with '!' to exclude. Use '@' for any value and '!@' for none. */
    reportUuid?: string[] | null;
    /** Filter for shipments from (non-)OSSI member companies */
    isOSSIMember?: boolean | null;
  };
}

export enum InvoicesCreateListParamsSortby {
  Obl = "obl",
  ShippedAt = "shippedAt",
  Teu = "teu",
  CarrierName = "carrierName",
  MemberName = "memberName",
  OriginLocation = "originLocation",
  DestinationLocation = "destinationLocation",
  CreatedAt = "createdAt",
}

export interface InvoicesUpdatePayload {
  title: string;
  description: string;
}

export interface InvoicesShipmentsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** Filter invoice shipment rows (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
  };
  /** the path parameter for the invoice UID */
  invoiceUid?: string;
}

export interface InvoicesExportListParams {
  /** Filter invoice shipment rows (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
  };
  /** the path parameter for the invoice UID */
  invoiceUid?: string;
}

export interface InvoicesMarkPaidUpdatePayload {
  /** UUIDs of the invoice rows to mark as paid/unpaid */
  invoiceRowUuids: string[];
  /**
   * Date to mark the rows as paid. If null, marks the rows as unpaid
   * @format date-time
   */
  paidAt: Date | null;
}

export interface ReportsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** order shipment reports by this value (default by createdAt) */
  sortby?: ReportsListParamsSortby;
  /** Filter shipment reports (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    /** Filter by report titles (partial match) */
    title?: string[] | null;
    /** Filter by report UUIDs */
    reportUuid?: string[] | null;
    /** Filter by company UIDs */
    companyUid?: string[] | null;
    /** Filter by report type (member or carrier) */
    type?: ReportType[] | null;
    createdAt?: {
      /**
       * Filter reports created after this date
       * @format date-time-filter
       */
      from?: Date | "@" | "!@";
      /**
       * Filter reports created before this date
       * @format date-time-filter
       */
      to?: Date | "@" | "!@";
    } | null;
  };
}

/** order shipment reports by this value (default by createdAt) */
export enum ReportsListParamsSortby {
  Title = "title",
  CreatedAt = "createdAt",
  Type = "type",
  CompanyName = "companyName",
}

export interface VidBatchesListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** order VID batches by this value (default by createdAt) */
  sortby?: VidBatchesListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    /** Filter by batch titles (partial match) */
    title?: string[] | null;
    /** Filter by VID batch UIDs */
    vidBatchUid?: string[] | null;
    /** Filter by VID batch type */
    type?: VIDType[] | null;
    createdAt?: {
      /**
       * Filter batches created after this date
       * @format date-time-filter
       */
      from?: Date | "@" | "!@";
      /**
       * Filter batches created before this date
       * @format date-time-filter
       */
      to?: Date | "@" | "!@";
    } | null;
  };
}

/** order VID batches by this value (default by createdAt) */
export enum VidBatchesListParamsSortby {
  Title = "title",
  CreatedAt = "createdAt",
  Type = "type",
  Uid = "uid",
  ShipmentCount = "shipmentCount",
  TeuCount = "teuCount",
  SumTotal = "sumTotal",
}

export interface VidBatchesCreatePayload {
  /** The title for the new VID batch */
  title: string;
  /** The description for the new VID batch */
  description: string;
  /**
   * The type of VID batch (vid, ossi_vid, top_up_vid)
   * @format vid-type-enum
   */
  type: VIDType;
  /**
   * The price per TEU to apply to all items in this batch
   * @min 0
   */
  teuPrice: number;
  /** List of standard shipment items to be included in the batch. */
  items?:
    | {
        /** The OBL identifier of the shipment to include. */
        obl: string;
        /**
         * The specific TEU amount to batch for this OBL. Positive value converted to negative when it becomes a credit row.
         * @format float
         * @min 0.01
         */
        teu: number;
      }[]
    | null;
  /** List of correction items (referenced by UID) to be included in the batch. */
  corrections?:
    | {
        /** The OBL identifier of the shipment to include. */
        obl: string;
        /**
         * The specific TEU amount to batch for this OBL. Negative for credits, positive for debits.
         * @format float
         */
        teu: number;
        /** The unique identifier of the correction item. */
        uid: string;
      }[]
    | null;
  /**
   * Optional start date for the period this batch covers
   * @format date-time
   */
  periodStartAt?: Date | null;
  /**
   * Optional end date for the period this batch covers
   * @format date-time
   */
  periodEndAt?: Date | null;
}

export interface VidBatchesCreateListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: VidBatchesCreateListParamsSortby;
  /** Filter active shipments (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    contractCode?: string[] | null;
    memberReference?: string[] | null;
    carrierBookingNumber?: string[] | null;
    /** UIDs of the carrier companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    carrierCompanyId?: string[] | null;
    /** UIDs of the member companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    memberCompanyId?: string[] | null;
    shippedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    reportedBy?: ReportedBy[] | null;
    canBeInvoiced?: boolean | null;
    hasUninvoicedTeu?: boolean | null;
    /** Filter for shipments where invoiced TEU > shipped TEU (potential correction needed) */
    canBeCorrected?: boolean | null;
    /** Filter for shipments where invoiced TEU > 0 */
    hasBeenInvoiced?: boolean | null;
    /** Filter by invoice UIDs present in the financeStatus.invoices array */
    invoiceUid?: string[] | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeVidBatched?: boolean | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeTopUpVidBatched?: boolean | null;
    /** Filter for shipments that have staged VID corrections */
    hasVidCorrections?: boolean | null;
    /** Filter by shipment report UUID from a member/carrier import. Prefix with '!' to exclude. Use '@' for any value and '!@' for none. */
    reportUuid?: string[] | null;
    /** Filter for shipments from (non-)OSSI member companies */
    isOSSIMember?: boolean | null;
  };
}

export enum VidBatchesCreateListParamsSortby {
  Obl = "obl",
  ShippedAt = "shippedAt",
  Teu = "teu",
  CarrierName = "carrierName",
  MemberName = "memberName",
  OriginLocation = "originLocation",
  DestinationLocation = "destinationLocation",
  CreatedAt = "createdAt",
}

export interface VidBatchesCorrectionsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: VidBatchesCorrectionsListParamsSortby;
  /** Filter active shipments (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    contractCode?: string[] | null;
    memberReference?: string[] | null;
    carrierBookingNumber?: string[] | null;
    /** UIDs of the carrier companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    carrierCompanyId?: string[] | null;
    /** UIDs of the member companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    memberCompanyId?: string[] | null;
    shippedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    reportedBy?: ReportedBy[] | null;
    canBeInvoiced?: boolean | null;
    hasUninvoicedTeu?: boolean | null;
    /** Filter for shipments where invoiced TEU > shipped TEU (potential correction needed) */
    canBeCorrected?: boolean | null;
    /** Filter for shipments where invoiced TEU > 0 */
    hasBeenInvoiced?: boolean | null;
    /** Filter by invoice UIDs present in the financeStatus.invoices array */
    invoiceUid?: string[] | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeVidBatched?: boolean | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeTopUpVidBatched?: boolean | null;
    /** Filter for shipments that have staged VID corrections */
    hasVidCorrections?: boolean | null;
    /** Filter by shipment report UUID from a member/carrier import. Prefix with '!' to exclude. Use '@' for any value and '!@' for none. */
    reportUuid?: string[] | null;
    /** Filter for shipments from (non-)OSSI member companies */
    isOSSIMember?: boolean | null;
  };
}

export enum VidBatchesCorrectionsListParamsSortby {
  Obl = "obl",
  ShippedAt = "shippedAt",
  Teu = "teu",
  CarrierName = "carrierName",
  MemberName = "memberName",
  OriginLocation = "originLocation",
  DestinationLocation = "destinationLocation",
  CreatedAt = "createdAt",
}

export interface VidBatchesTopUpableListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: VidBatchesTopUpableListParamsSortby;
  /** Filter active shipments (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    contractCode?: string[] | null;
    memberReference?: string[] | null;
    carrierBookingNumber?: string[] | null;
    /** UIDs of the carrier companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    carrierCompanyId?: string[] | null;
    /** UIDs of the member companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    memberCompanyId?: string[] | null;
    shippedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    reportedBy?: ReportedBy[] | null;
    canBeInvoiced?: boolean | null;
    hasUninvoicedTeu?: boolean | null;
    /** Filter for shipments where invoiced TEU > shipped TEU (potential correction needed) */
    canBeCorrected?: boolean | null;
    /** Filter for shipments where invoiced TEU > 0 */
    hasBeenInvoiced?: boolean | null;
    /** Filter by invoice UIDs present in the financeStatus.invoices array */
    invoiceUid?: string[] | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeVidBatched?: boolean | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeTopUpVidBatched?: boolean | null;
    /** Filter for shipments that have staged VID corrections */
    hasVidCorrections?: boolean | null;
    /** Filter by shipment report UUID from a member/carrier import. Prefix with '!' to exclude. Use '@' for any value and '!@' for none. */
    reportUuid?: string[] | null;
    /** Filter for shipments from (non-)OSSI member companies */
    isOSSIMember?: boolean | null;
  };
}

export enum VidBatchesTopUpableListParamsSortby {
  Obl = "obl",
  ShippedAt = "shippedAt",
  Teu = "teu",
  CarrierName = "carrierName",
  MemberName = "memberName",
  OriginLocation = "originLocation",
  DestinationLocation = "destinationLocation",
  CreatedAt = "createdAt",
}

export interface VidBatchesDetailParams {
  /** order memberBatches by this value (default by memberName) */
  sortby?: VidBatchesDetailParamsSortby;
  /** the path parameter for the VID batch UID */
  vidBatchUid: string;
}

/** order memberBatches by this value (default by memberName) */
export enum VidBatchesDetailParamsSortby {
  MemberName = "memberName",
  ShipmentCount = "shipmentCount",
  TotalTeu = "totalTeu",
  TotalAmount = "totalAmount",
}

export interface VidBatchesUpdatePayload {
  title?: string;
  description?: string;
}

export interface VidBatchesMembersShipmentsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** order VID batch member rows by this value (default by shippedAt) */
  sortby?: VidBatchesMembersShipmentsListParamsSortby;
  /** Filter VID batch member rows. */
  f?: {
    /** Filter rows by OBL ID(s). */
    obl?: string[] | null;
  };
  /** the path parameter for the VID batch UID */
  vidBatchUid: string;
  /**
   * The UID of the member company.
   * @format uuid
   */
  memberUid: string;
}

/** order VID batch member rows by this value (default by shippedAt) */
export enum VidBatchesMembersShipmentsListParamsSortby {
  Obl = "obl",
  Teu = "teu",
  Amount = "amount",
  ShippedAt = "shippedAt",
  CreatedAt = "createdAt",
}

export interface VidBatchesMembersExportListParams {
  /** order VID batch member rows by this value (default by shippedAt) */
  sortby?: VidBatchesMembersExportListParamsSortby;
  /** Filter VID batch member rows. */
  f?: {
    /** Filter rows by OBL ID(s). */
    obl?: string[] | null;
  };
  /** the path parameter for the VID batch UID */
  vidBatchUid: string;
  /**
   * The UID of the member company.
   * @format uuid
   */
  memberUid: string;
}

/** order VID batch member rows by this value (default by shippedAt) */
export enum VidBatchesMembersExportListParamsSortby {
  Obl = "obl",
  Teu = "teu",
  Amount = "amount",
  ShippedAt = "shippedAt",
  CreatedAt = "createdAt",
}

export interface VidBatchesTopUpCreatePayload {
  /** The title for the new VID batch */
  title: string;
  /** The description for the new VID batch */
  description: string;
  /**
   * The price per TEU to apply to all items in this batch
   * @min 0
   */
  teuPrice: number;
  /**
   * Optional start date for the period this batch covers
   * @format date-time
   */
  periodStartAt?: Date | null;
  /**
   * Optional end date for the period this batch covers
   * @format date-time
   */
  periodEndAt?: Date | null;
}

export interface VidBatchesTopUpCreateParams {
  /** Filter active shipments (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    obl?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    contractCode?: string[] | null;
    memberReference?: string[] | null;
    carrierBookingNumber?: string[] | null;
    /** UIDs of the carrier companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    carrierCompanyId?: string[] | null;
    /** UIDs of the member companies to match. Prefix a value with '!' to exclude it. Use '@' for any value and '!@' for none. */
    memberCompanyId?: string[] | null;
    shippedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    reportedBy?: ReportedBy[] | null;
    canBeInvoiced?: boolean | null;
    hasUninvoicedTeu?: boolean | null;
    /** Filter for shipments where invoiced TEU > shipped TEU (potential correction needed) */
    canBeCorrected?: boolean | null;
    /** Filter for shipments where invoiced TEU > 0 */
    hasBeenInvoiced?: boolean | null;
    /** Filter by invoice UIDs present in the financeStatus.invoices array */
    invoiceUid?: string[] | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeVidBatched?: boolean | null;
    /** Filter for shipments where amount paid > amount VID batched (potential VID batch candidates) */
    canBeTopUpVidBatched?: boolean | null;
    /** Filter for shipments that have staged VID corrections */
    hasVidCorrections?: boolean | null;
    /** Filter by shipment report UUID from a member/carrier import. Prefix with '!' to exclude. Use '@' for any value and '!@' for none. */
    reportUuid?: string[] | null;
    /** Filter for shipments from (non-)OSSI member companies */
    isOSSIMember?: boolean | null;
  };
}

export interface SearchLocationsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** order locations by this value (default by name) */
  sortby?: SearchLocationsListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). */
  f?: {
    terminus?: TerminusType[] | null;
    locationType?: LocationType[] | null;
    values?: string[] | null;
  };
  /** Used to denote a historical search */
  historic?: boolean;
}

/** order locations by this value (default by name) */
export enum SearchLocationsListParamsSortby {
  Name = "name",
  Type = "type",
  GroupType = "groupType",
  PlainName = "plainName",
  SubDivision = "subDivision",
  CountryCode = "countryCode",
  PlaceCode = "placeCode",
  Unlocode = "unlocode",
  Terminus = "terminus",
}

export interface CarriersListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: CarriersListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    uid?: string[] | null;
    name?: string[] | null;
    companyType?: CompanyType[] | null;
    address?: string[] | null;
    postCode?: string[] | null;
    city?: string[] | null;
    country?: string[] | null;
    website?: string[] | null;
    phone?: string[] | null;
    fax?: string[] | null;
    invoiceAddress?: string[] | null;
    invoicePostCode?: string[] | null;
    invoiceCity?: string[] | null;
    invoiceCountry?: string[] | null;
    isActive?: (string | boolean)[] | null;
    vat?: string[] | null;
    deactivatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    archivedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    carrierDetails?: (boolean | string)[] | null;
    memberDetails?: (boolean | string)[] | null;
    fromPortal?: boolean[] | null;
  };
}

export enum CarriersListParamsSortby {
  Country = "country",
  Name = "name",
  Address = "address",
  PostCode = "postCode",
  City = "city",
  InvoiceAddress = "invoiceAddress",
  InvoicePostCode = "invoicePostCode",
  InvoiceCity = "invoiceCity",
  InvoiceCountry = "invoiceCountry",
  DeactivatedAt = "deactivatedAt",
  CompanyType = "companyType",
}

export interface SearchDetailParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: SearchDetailParamsSortby;
  /** @format equipment-type-enum */
  sortBase?: EquipmentType;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    carrierUid?: string[] | null;
    equipmentType?: EquipmentType[] | null;
    commodityTitle?: string[] | null;
  };
  /** Used to denote a historical search */
  historic?: boolean;
  searchUuid: string;
}

export enum SearchDetailParamsSortby {
  Price = "price",
  Speed = "speed",
  Co2 = "co2",
}

export interface SearchExportListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: SearchExportListParamsSortby;
  /** @format equipment-type-enum */
  sortBase?: EquipmentType;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    carrierUid?: string[] | null;
    equipmentType?: EquipmentType[] | null;
    commodityTitle?: string[] | null;
  };
  /** Used to denote a historical search */
  historic?: boolean;
  searchUuid: string;
}

export enum SearchExportListParamsSortby {
  Price = "price",
  Speed = "speed",
  Co2 = "co2",
}

export interface ResultsDetailParams {
  /** Used to denote a historical search */
  historic?: boolean;
  searchUuid: string;
  searchResultUuid: string;
}

export interface SearchCreatePayload {
  origins: string[];
  destinations: string[];
  /**
   * @minLength 3
   * @maxLength 3
   */
  currency?: string;
  carrierUids?: string[];
  /** @format date-time */
  searchOnDate?: Date | null;
  includeNearby?: boolean | null;
}

export interface TemplateLegsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: TemplateLegsListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    templateLegId?: string[] | null;
    originUnlocodeGroup?: string[] | null;
    destinationUnlocodeGroup?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    originCountry?: string[] | null;
    originPlace?: string[] | null;
    destinationCountry?: string[] | null;
    destinationPlace?: string[] | null;
    equipmentType?: EquipmentType[] | null;
    modality?: Modality[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  };
}

export enum TemplateLegsListParamsSortby {
  TemplateLegId = "templateLegId",
  OriginCountry = "originCountry",
  OriginPlace = "originPlace",
  DestinationCountry = "destinationCountry",
  DestinationPlace = "destinationPlace",
  EquipmentType = "equipmentType",
  Modality = "modality",
}

export interface TemplateLegsCreatePayload {
  originCountry: string;
  originPlace: string;
  destinationCountry: string;
  destinationPlace: string;
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  /** @format modality-enum */
  modality: Modality;
}

export interface BulkUpsertPayload {
  originCountry: string;
  originPlace: string;
  destinationCountry: string;
  destinationPlace: string;
  /** @format modality-enum */
  modality: Modality;
  equipmentTypes: EquipmentType[];
}

export interface LocationsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** order locations by this value (default by name) */
  sortby?: LocationsListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). */
  f?: {
    terminus?: TerminusType[] | null;
    locationType?: LocationType[] | null;
    values?: string[] | null;
  };
}

/** order locations by this value (default by name) */
export enum LocationsListParamsSortby {
  Name = "name",
  Type = "type",
  GroupType = "groupType",
  PlainName = "plainName",
  SubDivision = "subDivision",
  CountryCode = "countryCode",
  PlaceCode = "placeCode",
  Unlocode = "unlocode",
  Terminus = "terminus",
}

export interface TemplateLegsUpdatePayload {
  originCountry: string;
  originPlace: string;
  destinationCountry: string;
  destinationPlace: string;
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  /** @format modality-enum */
  modality: Modality;
}

export interface ContractLegsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: ContractLegsListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    templateLegId?: string[] | null;
    originUnlocodeGroup?: string[] | null;
    destinationUnlocodeGroup?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    originCountry?: string[] | null;
    originPlace?: string[] | null;
    destinationCountry?: string[] | null;
    destinationPlace?: string[] | null;
    equipmentType?: EquipmentType[] | null;
    modality?: Modality[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  } & {
    status?: ContractLegStatus[] | null;
    changeType?: AmendmentChangeType[] | null;
    service?: string[] | null;
    tradeLane?:
      | {
          origin?: string;
          destination?: string;
        }[]
      | null;
    groupUuid?: string[] | null;
    legUuid?: string[] | null;
    contractId?: string[] | null;
    costBaseRate?: {
      from?: number | null;
      to?: number | null;
    }[];
    costBaseRateCurrency?: string[] | null;
    timeTransit?: {
      from?: number | null;
      to?: number | null;
    }[];
    activeAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    expiredAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    /** @format contract-leg-grouping-enum */
    legGrouping?: ContractLegQueryFilterLegGrouping;
  };
  tenderUid: string;
}

export enum ContractLegsListParamsSortby {
  TemplateLegId = "templateLegId",
  OriginCountry = "originCountry",
  OriginPlace = "originPlace",
  DestinationCountry = "destinationCountry",
  DestinationPlace = "destinationPlace",
  EquipmentType = "equipmentType",
  Modality = "modality",
  GroupUuid = "groupUuid",
  LegUuid = "legUuid",
  Status = "status",
}

export type ContractLegsCreatePayload = {
  /** @format date-time */
  activeAt?: Date | null;
  /** @format date-time */
  expiredAt?: Date | null;
  service?: string | null;
  tradeLane?: {
    origin: string;
    destination: string;
  } | null;
  declined: boolean;
  equipmentShipperOwned?: boolean | null;
  originPortStorageIncluded?: boolean | null;
  destinationPortStorageIncluded?: boolean | null;
  transshipment?: string | null;
  numberOfSailings?: number | null;
  sailingFrequency?: string | null;
  co2Amount?: number | null;
  shipperComments?: string | null;
  carrierComments?: string | null;
  contractLegFieldsCost?:
    | {
        fieldName: string;
        value: number;
        /**
         * @minLength 3
         * @maxLength 3
         */
        unit: string;
      }[]
    | null;
  contractLegFieldsTime?:
    | {
        fieldName: string;
        value: number;
        /** @format days-type-enum */
        unit: DaysType;
      }[]
    | null;
} & {
  originCountry: string;
  originPlace: string;
  destinationCountry: string;
  destinationPlace: string;
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  /** @format modality-enum */
  modality: Modality;
};

export interface ContractLegsLocationsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** order locations by this value (default by name) */
  sortby?: ContractLegsLocationsListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). */
  f?: {
    terminus?: TerminusType[] | null;
    locationType?: LocationType[] | null;
    values?: string[] | null;
  };
  tenderUid: string;
}

/** order locations by this value (default by name) */
export enum ContractLegsLocationsListParamsSortby {
  Name = "name",
  Type = "type",
  GroupType = "groupType",
  PlainName = "plainName",
  SubDivision = "subDivision",
  CountryCode = "countryCode",
  PlaceCode = "placeCode",
  Unlocode = "unlocode",
  Terminus = "terminus",
}

export interface ContractLegsUpdatePayload {
  /** @format date-time */
  activeAt?: Date | null;
  /** @format date-time */
  expiredAt?: Date | null;
  service?: string | null;
  tradeLane?: {
    origin: string;
    destination: string;
  } | null;
  declined: boolean;
  equipmentShipperOwned?: boolean | null;
  originPortStorageIncluded?: boolean | null;
  destinationPortStorageIncluded?: boolean | null;
  transshipment?: string | null;
  numberOfSailings?: number | null;
  sailingFrequency?: string | null;
  co2Amount?: number | null;
  shipperComments?: string | null;
  carrierComments?: string | null;
  contractLegFieldsCost?:
    | {
        fieldName: string;
        value: number;
        /**
         * @minLength 3
         * @maxLength 3
         */
        unit: string;
      }[]
    | null;
  contractLegFieldsTime?:
    | {
        fieldName: string;
        value: number;
        /** @format days-type-enum */
        unit: DaysType;
      }[]
    | null;
}

export interface TendersListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: TendersListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    uid?: string[] | null;
    title?: string[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    parentTenderUid?: string[] | null;
    company?: string[] | null;
    publishedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    acceptedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    activeAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    expiredAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    defaultResponseDueAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    status?: ContractStatusType[] | null;
    activeAtExpiredAtRange?: {
      activeAt?: {
        /** @format date-time */
        from?: Date;
        /** @format date-time */
        to?: Date;
      } | null;
      expiredAt?: {
        /** @format date-time */
        from?: Date;
        /** @format date-time */
        to?: Date;
      } | null;
    }[];
  };
}

export enum TendersListParamsSortby {
  Title = "title",
  Uid = "uid",
  ParentTenderUid = "parentTenderUid",
  Company = "company",
  ContractAccessCompanyUid = "contractAccess.companyUid",
  ContractAccessCompanyName = "contractAccess.companyName",
  ContractAccessDueDate = "contractAccess.dueDate",
  PublishedAt = "publishedAt",
  AcceptedAt = "acceptedAt",
  ActiveAt = "activeAt",
  ExpiredAt = "expiredAt",
  DefaultResponseDueAt = "defaultResponseDueAt",
  CreatedAt = "createdAt",
  UpdatedAt = "updatedAt",
}

export interface TendersCreatePayload {
  title: string;
  contractFields?: {
    name: string;
    isActive: boolean;
    isRequired: boolean;
  }[];
  access?: {
    companyUid: string;
    /** @format date-time */
    dueDate?: Date | null;
  }[];
  /** @format date-time */
  activeAt?: Date;
  /** @format date-time */
  expiredAt?: Date;
  /** @format date-time */
  defaultResponseDueAt?: Date;
  file?: File;
}

export interface AutomaticCreatePayload {
  tenders: {
    uid: string;
    /** @format tender-region-enum */
    regionType: TenderRegionTypes;
  }[];
}

export interface BenchmarkExportListParams {
  /** The contract year to export the benchmark for (1st March - Last of February) */
  contractYear?: string;
}

export interface TendersUpdatePayload {
  title: string;
  contractFields?: {
    name: string;
    isActive: boolean;
    isRequired: boolean;
  }[];
  access?: {
    companyUid: string;
    /** @format date-time */
    dueDate?: Date | null;
  }[];
  /** @format date-time */
  activeAt?: Date;
  /** @format date-time */
  expiredAt?: Date;
  /** @format date-time */
  defaultResponseDueAt?: Date;
}

export interface ImportUpdateBody {
  file?: File;
}

export interface ResponsesCreatePayload {
  title: string;
}

export interface TenderExportListParams {
  sortby?: TenderExportListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    templateLegId?: string[] | null;
    originUnlocodeGroup?: string[] | null;
    destinationUnlocodeGroup?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    originCountry?: string[] | null;
    originPlace?: string[] | null;
    destinationCountry?: string[] | null;
    destinationPlace?: string[] | null;
    equipmentType?: EquipmentType[] | null;
    modality?: Modality[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  };
  tenderUid: string;
}

export enum TenderExportListParamsSortby {
  TemplateLegId = "templateLegId",
  OriginCountry = "originCountry",
  OriginPlace = "originPlace",
  DestinationCountry = "destinationCountry",
  DestinationPlace = "destinationPlace",
  EquipmentType = "equipmentType",
  Modality = "modality",
}

export interface TenderLegsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: TenderLegsListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    templateLegId?: string[] | null;
    originUnlocodeGroup?: string[] | null;
    destinationUnlocodeGroup?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    originCountry?: string[] | null;
    originPlace?: string[] | null;
    destinationCountry?: string[] | null;
    destinationPlace?: string[] | null;
    equipmentType?: EquipmentType[] | null;
    modality?: Modality[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  };
  tenderUid: string;
}

export enum TenderLegsListParamsSortby {
  TemplateLegId = "templateLegId",
  OriginCountry = "originCountry",
  OriginPlace = "originPlace",
  DestinationCountry = "destinationCountry",
  DestinationPlace = "destinationPlace",
  EquipmentType = "equipmentType",
  Modality = "modality",
}

export interface TenderLegsCreatePayload {
  originCountry: string;
  originPlace: string;
  destinationCountry: string;
  destinationPlace: string;
  /** @format equipment-type-enum */
  equipmentType: EquipmentType;
  /** @format modality-enum */
  modality: Modality;
}

export interface TenderLegsDeleteParams {
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    templateLegId?: string[] | null;
    originUnlocodeGroup?: string[] | null;
    destinationUnlocodeGroup?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    originCountry?: string[] | null;
    originPlace?: string[] | null;
    destinationCountry?: string[] | null;
    destinationPlace?: string[] | null;
    equipmentType?: EquipmentType[] | null;
    modality?: Modality[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  };
  tenderUid: string;
}

export interface TenderLegsLocationsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** order locations by this value (default by name) */
  sortby?: TenderLegsLocationsListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). */
  f?: {
    terminus?: TerminusType[] | null;
    locationType?: LocationType[] | null;
    values?: string[] | null;
  };
  tenderUid: string;
}

/** order locations by this value (default by name) */
export enum TenderLegsLocationsListParamsSortby {
  Name = "name",
  Type = "type",
  GroupType = "groupType",
  PlainName = "plainName",
  SubDivision = "subDivision",
  CountryCode = "countryCode",
  PlaceCode = "placeCode",
  Unlocode = "unlocode",
  Terminus = "terminus",
}

export interface TenderLegsTenderLegChangeCreatePayload {
  remove?: {
    originCountry: string;
    originPlace: string;
    destinationCountry: string;
    destinationPlace: string;
    /** @format equipment-type-enum */
    equipmentType: EquipmentType;
    /** @format modality-enum */
    modality: Modality;
  };
  add?: {
    originCountry: string;
    originPlace: string;
    destinationCountry: string;
    destinationPlace: string;
    /** @format equipment-type-enum */
    equipmentType: EquipmentType;
    /** @format modality-enum */
    modality: Modality;
  };
}

export interface TenderLegsFilteredCreateParams {
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    templateLegId?: string[] | null;
    originUnlocodeGroup?: string[] | null;
    destinationUnlocodeGroup?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    originCountry?: string[] | null;
    originPlace?: string[] | null;
    destinationCountry?: string[] | null;
    destinationPlace?: string[] | null;
    equipmentType?: EquipmentType[] | null;
    modality?: Modality[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  };
  tenderUid: string;
}

export interface TenderResponsesUpdatePayload {
  title: string;
}

export interface ImportUpdateInput {
  file?: File;
}

export interface TenderResponseExportCreateParams {
  /** Whether to populate the export rows with current active leg values */
  prepopulate?: boolean;
  sortby?: TenderResponseExportCreateParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: ({
    templateLegId?: string[] | null;
    originUnlocodeGroup?: string[] | null;
    destinationUnlocodeGroup?: string[] | null;
    originUnlocode?: string[] | null;
    destinationUnlocode?: string[] | null;
    originCountry?: string[] | null;
    originPlace?: string[] | null;
    destinationCountry?: string[] | null;
    destinationPlace?: string[] | null;
    equipmentType?: EquipmentType[] | null;
    modality?: Modality[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  } & {
    status?: ContractLegStatus[] | null;
    changeType?: AmendmentChangeType[] | null;
    service?: string[] | null;
    tradeLane?:
      | {
          origin?: string;
          destination?: string;
        }[]
      | null;
    groupUuid?: string[] | null;
    legUuid?: string[] | null;
    contractId?: string[] | null;
    costBaseRate?: {
      from?: number | null;
      to?: number | null;
    }[];
    costBaseRateCurrency?: string[] | null;
    timeTransit?: {
      from?: number | null;
      to?: number | null;
    }[];
    activeAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    expiredAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    /** @format contract-leg-grouping-enum */
    legGrouping?: ContractLegQueryFilterLegGrouping;
  }) & {
    declined?: (string | boolean)[] | null;
  };
  tenderUid: string;
}

export enum TenderResponseExportCreateParamsSortby {
  TemplateLegId = "templateLegId",
  OriginCountry = "originCountry",
  OriginPlace = "originPlace",
  DestinationCountry = "destinationCountry",
  DestinationPlace = "destinationPlace",
  EquipmentType = "equipmentType",
  Modality = "modality",
}

export interface UnlocodesListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** order unlocodes by this value (default by name) */
  sortby?: UnlocodesListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    searchTerm?: string[];
    countryCode?: string[] | null;
    name?: string[] | null;
    placeCode?: string[] | null;
    plainName?: string[] | null;
    status?: string[] | null;
    subDivision?: string[] | null;
    IATA?: string[] | null;
    unlocode?: string[] | null;
    unlocodeGroupId?: string[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    coordinates?: QueryCoordinate[][] | null;
  };
}

/** order unlocodes by this value (default by name) */
export enum UnlocodesListParamsSortby {
  Name = "name",
  Unlocode = "unlocode",
  CountryCode = "countryCode",
  PlaceCode = "placeCode",
  Status = "status",
}

export interface UnlocodesCreatePayload {
  /** Two letter country code */
  countryCode: string;
  /** Three character place code */
  placeCode: string;
  /** The place name with diacritical marks */
  name: string;
  /** The coordinates (empty allowed) */
  coordinates: {
    long: number;
    lat: number;
  } | null;
  /** The sub-division code (empty allowed) */
  subDivision: string;
}

export interface UnlocodesUpdatePayload {
  /** Two letter country code */
  countryCode: string;
  /** Three character place code */
  placeCode: string;
  /** The place name with diacritical marks */
  name: string;
  /** The coordinates (empty allowed) */
  coordinates: {
    long: number;
    lat: number;
  } | null;
  /** The sub-division code (empty allowed) */
  subDivision: string;
}

export interface UnlocodeGroupsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  sortby?: UnlocodeGroupsListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    id?: string[] | null;
    name?: string[] | null;
    type?: string[] | null;
    description?: string[] | null;
  };
}

export enum UnlocodeGroupsListParamsSortby {
  Name = "name",
  Type = "type",
  CreatedAt = "createdAt",
  UpdatedAt = "updatedAt",
}

export interface UnlocodeGroupsCreatePayload {
  name: string;
  description: string;
  /** @format unlocodegroup-type-enum */
  type: UnlocodeGroupType;
}

export interface UnlocodeGroupsUpdatePayload {
  name: string;
  description: string;
  /** @format unlocodegroup-type-enum */
  type: UnlocodeGroupType;
}

export interface GroupUnlocodesListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** order unlocodes by this value (default by name) */
  sortby?: GroupUnlocodesListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    searchTerm?: string[];
    countryCode?: string[] | null;
    name?: string[] | null;
    placeCode?: string[] | null;
    plainName?: string[] | null;
    status?: string[] | null;
    subDivision?: string[] | null;
    IATA?: string[] | null;
    unlocode?: string[] | null;
    unlocodeGroupId?: string[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    coordinates?: QueryCoordinate[][] | null;
  };
  unlocodeGroupId: string;
}

/** order unlocodes by this value (default by name) */
export enum GroupUnlocodesListParamsSortby {
  Name = "name",
  Unlocode = "unlocode",
  CountryCode = "countryCode",
  PlaceCode = "placeCode",
  Status = "status",
}

export interface GroupUnlocodesUpdatePayload {
  added: string[];
  removed: string[];
}

export interface UsersListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** Query to search by */
  query?: string;
  /** order users by this value (default by email) */
  sortby?: UsersListParamsSortby;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    uid?: string[] | null;
    firstName?: string[] | null;
    lastName?: string[] | null;
    phone?: string[] | null;
    language?: string[] | null;
    country?: string[] | null;
    companyUid?: string[] | null;
    isSuperAdmin?: (string | boolean)[] | null;
    isBlocked?: (string | boolean)[] | null;
    email?: string[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    updatedAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
    fullName?: string[] | null;
  };
}

/** order users by this value (default by email) */
export enum UsersListParamsSortby {
  Email = "email",
  Company = "company",
  Type = "type",
  Blocked = "blocked",
}

export interface UsersCreatePayload {
  email: string;
  language?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  country?: string | null;
  userGroups?: UserGroupName[];
  companyUid: string;
  isBlocked?: boolean;
}

export interface UsersUpdatePayload {
  email: string;
  language?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  country?: string | null;
  userGroups?: UserGroupName[];
  companyUid: string;
  isBlocked?: boolean;
}

export interface UserLogsListParams {
  /** Page offset for pagination. */
  page?: number;
  /** Number of elements to display per page. */
  limit?: number;
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    ipAddress?: string[] | null;
    userEmail?: string[] | null;
    /** Filter by company UIDs */
    companyUid?: string[] | null;
    /** Filter by company name (partial match) */
    companyName?: string[] | null;
    /** Filter by user full name (partial match) */
    fullName?: string[] | null;
    /** Filter by blocked status. Use false for active users, true for blocked users. */
    isBlocked?: (string | boolean)[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  };
}

export interface ExportUserLogsListParams {
  /** Filter (using 'f' as short version to shorten resulting URL:s). Supports filter operations: !, @, !@ */
  f?: {
    ipAddress?: string[] | null;
    userEmail?: string[] | null;
    /** Filter by company UIDs */
    companyUid?: string[] | null;
    /** Filter by company name (partial match) */
    companyName?: string[] | null;
    /** Filter by user full name (partial match) */
    fullName?: string[] | null;
    /** Filter by blocked status. Use false for active users, true for blocked users. */
    isBlocked?: (string | boolean)[] | null;
    createdAt?:
      | {
          /** @format date-time-filter */
          from?: Date | "@" | "!@";
          /** @format date-time-filter */
          to?: Date | "@" | "!@";
        }[]
      | null;
  };
}
